import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import {
    AddwithWhiteCircle,
    CloudUpload,
    CrosswithGreyCircle,
    DeleteDustbin,
    Eye,
    InfoIcon,
    Printer,
    UpdatePencil,
} from "../../AllSvg";
import TipTapEditor from "./TipTapEditor";
import TipTapLetterEditor from "./TipTapLetterEditor";
import "./tiptap-editor.css";
import { BASE_URL } from "../../../config/axios";
import { CustomTooltip, handleErrorToast, renderDangerousHTML } from "../../CustomFunctions";
import { CSSForSelect, CustomCSSForSearchableSelect, lineHeightOptions, staticVariableOptions, toolTipContent } from "../../CustomUtilities";
import { customSortByKey } from "../../CustomFunctions";
import ReactToPrint from "react-to-print";
import { ViewFile } from "../../CustomFunctions";
import Loader from "../../Loader";
import { LetterPreview } from "../LetterDisplayComponents/LetterPreview";
import Select from 'react-select';
import CreatableSelect from "react-select/creatable";

const getEmpDataValue = (empData, varName) => {
    if (!varName || !empData) return undefined;
    if (empData[varName] !== undefined) return empData[varName];

    const normalize = (value) =>
        value?.toString().trim().toLowerCase().replace(/\s+/g, "_");

    const normalizedVar = normalize(varName);
    const foundKey = Object.keys(empData).find(
        (key) => normalize(key) === normalizedVar
    );

    return foundKey ? empData[foundKey] : undefined;
};

const AddLetterTemplate = ({
    SUB_COMPANIES,
    SUPER_ADMIN,
    getLetterTemplateData,
}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const initialTemplateData = {
        template_name: "",
        sub_company: sessionStorage.getItem("company_id"),
        page_size: "A4",

        header_display: false,
        footer_display: false,
        bg_display: false,
        signatory_display: false,

        // Header fields
        header_logo: null,
        header_logo_size: 100,
        header_company_name: "",
        header_Address: "",
        header_email: "",
        header_primary_colour: "",
        header_secondery_colour: "",
        header_logo_position: "left",
        header_content_position: "right",
        header_full_image: null,
        header_left_gap: "",
        header_bottom_gap: "",
        header_right_gap: "",
        header_top_gap: "",

        // Background fields
        bg_image: null,
        bg_size: 100,
        bg_opacity: 20,

        //content field
        content_left_gap: "",
        content_right_gap: "",

        // Footer fields
        footer_logo: null,
        footer_logo_size: 100,
        footer_company_name: "",
        footer_email: "",
        footer_Address: "",
        footer_primary_colour: "",
        footer_secondery_colour: "",
        footer_logo_position: "left",
        footer_content_position: "right",
        footer_full_image: null,
        footer_left_gap: "",
        footer_bottom_gap: "",
        footer_right_gap: "",
        footer_top_gap: "",

        //Signature Fields
        signatory_sign_heading: "",
        signatory_name: "",
        signatory_designation: "",
        signatory_signature: "",
        signatory_sign_size: "",
        signatory_content_position: "left",
        signatory_sign_position: "left",
        signatory_overall_position: "left",
        signatory_overall_placement: "End",


    }
    const [formData, setFormData] = useState(initialTemplateData);

    const handleClose = () => {
        setShow(false);

        setFormData(initialTemplateData);
        setErrors({});
        setInputState({});
    };
    const handleShow = () => setShow(true);

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = ["template_name", "sub_company", "page_size"];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] =
                    `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });


        if (formData.signatory_display) {
            if (!formData.signatory_sign_heading?.trim()) {
                newErrors.signatory_sign_heading = "Signature heading is required!";
            }

            if (!formData.signatory_signature) {
                newErrors.signatory_signature = "Signature image is required!";
            }
        }

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };


    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (name === "header_full_image" && files && files[0]) {
            setFormData((prev) => ({
                ...prev,
                header_full_image: files[0],
                header_logo: null,
                header_company_name: "",
                header_Address: "",
                header_email: "",
                header_primary_colour: "",
                header_secondery_colour: "",
                header_left_gap: "",
                header_bottom_gap: "",
                header_right_gap: "",
                header_top_gap: "",
            }));

            document.querySelector(`input[name="header_logo"]`).value = "";
            return;
        }

        if (
            name.startsWith("header_") &&
            name !== "header_full_image" &&
            formData.header_full_image
        ) {
            setFormData((prev) => ({
                ...prev,
                header_full_image: null,
            }));
            document.querySelector(`input[name="header_full_image"]`).value = "";
        }

        if (name === "footer_full_image" && files && files[0]) {
            setFormData((prev) => ({
                ...prev,
                footer_full_image: files[0],
                footer_logo: null,
                footer_company_name: "",
                footer_Address: "",
                footer_email: "",
                footer_primary_colour: "",
                footer_secondery_colour: "",
                footer_left_gap: "",
                footer_bottom_gap: "",
                footer_right_gap: "",
                footer_top_gap: "",
            }));
            document.querySelector(`input[name="footer_logo"]`).value = "";

            return;
        }

        if (
            name.startsWith("footer_") &&
            name !== "footer_full_image" &&
            formData.footer_full_image
        ) {
            setFormData((prev) => ({
                ...prev,
                footer_full_image: null,
            }));
            document.querySelector(`input[name="footer_full_image"]`).value = "";
        }

        if (name === "header_display") {
            setFormData((prev) => {
                const updated = {
                    ...prev,
                    header_display: checked,
                };
                if (!checked) {
                    updated.header_logo = null;
                    updated.header_full_image = null;
                    updated.header_company_name = null;
                    updated.header_Address = null;
                    updated.header_email = null;
                    updated.header_primary_colour = null;
                    updated.header_secondery_colour = null;
                    updated.header_logo_size = null;
                    updated.header_logo_position = null;
                    updated.header_content_position = null;
                    updated.header_bottom_gap = null;
                    updated.header_right_gap = null;
                    updated.header_top_gap = null;
                    updated.header_left_gap = null;

                    const logoInput = document.querySelector('input[name="header_logo"]');
                    if (logoInput) logoInput.value = "";

                    const fullImgInput = document.querySelector(
                        'input[name="header_full_image"]'
                    );
                    if (fullImgInput) fullImgInput.value = "";

                    const fieldsToClear = [
                        "header_company_name",
                        "header_Address",
                        "header_email",
                        "header_primary_colour",
                        "header_secondery_colour",
                        "header_logo_size",
                        "header_logo_position",
                        "header_content_position",
                        "header_bottom_gap",
                        "header_right_gap",
                        "header_top_gap",
                        "header_left_gap",
                    ];

                    fieldsToClear.forEach((fieldName) => {
                        const input = document.querySelector(`input[name="${fieldName}"]`);
                        if (input) input.value = "";
                    });
                }
                return updated;
            });
            return;
        }

        if (name === "bg_display") {
            setFormData((prev) => {
                const updated = {
                    ...prev,
                    bg_display: checked,
                };
                if (!checked) {
                    updated.bg_image = null;
                    updated.bg_angle = null;
                    updated.content_left_gap = null;
                    updated.content_right_gap = null;
                    updated.bg_size = null;
                    updated.bg_opacity = null;

                    const bgInput = document.querySelector('input[name="bg_image"]');
                    if (bgInput) bgInput.value = "";

                    const fieldsToClear = [
                        "bg_angle",
                        "content_left_gap",
                        "content_right_gap",
                        "bg_size",
                        "bg_opacity",
                    ];

                    fieldsToClear.forEach((fieldName) => {
                        const input = document.querySelector(`input[name="${fieldName}"]`);
                        if (input) input.value = "";
                    });
                }
                return updated;
            });
            return;
        }

        if (name === "signatory_display") {
            setFormData((prev) => {
                const updated = {
                    ...prev,
                    signatory_display: checked,
                };

                if (!checked) {
                    updated.signatory_content_position = null;
                    updated.signatory_name = null;
                    updated.signatory_designation = null;
                    updated.signatory_sign_heading = null;
                    updated.signatory_signature = null;
                    updated.signatory_overall_position = null;
                    updated.signatory_sign_position = null;
                    updated.signatory_sign_size = null;
                    updated.signatory_overall_placement = null;

                    // clear signature file input
                    const signatureInput = document.querySelector(
                        'input[name="signatory_signature"]'
                    );
                    if (signatureInput) signatureInput.value = "";

                    const fieldsToClear = [
                        "signatory_content_position",
                        "signatory_name",
                        "signatory_designation",
                        "signatory_sign_heading",
                        "signatory_sign_size",
                    ];

                    fieldsToClear.forEach((fieldName) => {
                        const input = document.querySelector(`input[name="${fieldName}"]`);
                        if (input) input.value = "";
                    });
                }
                if (checked) {
                    updated.signatory_content_position ||= "left";
                    updated.signatory_sign_position ||= "left";
                    updated.signatory_overall_position ||= "left";
                    updated.signatory_sign_size ||= 100;
                    updated.signatory_overall_placement ||= "End";
                }


                return updated;
            });
            return;
        }


        if (name === "footer_display") {
            setFormData((prev) => {
                const updated = {
                    ...prev,
                    footer_display: checked,
                };
                if (!checked) {
                    updated.footer_logo = null;
                    updated.footer_full_image = null;
                    updated.footer_company_name = null;
                    updated.footer_Address = null;
                    updated.footer_email = null;
                    updated.footer_primary_colour = null;
                    updated.footer_secondery_colour = null;
                    updated.footer_logo_size = null;
                    updated.footer_logo_position = null;
                    updated.footer_content_position = null;
                    updated.footer_bottom_gap = null;
                    updated.footer_right_gap = null;
                    updated.footer_top_gap = null;
                    updated.footer_left_gap = null;

                    const logoInput = document.querySelector('input[name="footer_logo"]');
                    if (logoInput) logoInput.value = "";
                    const fullImgInput = document.querySelector(
                        'input[name="footer_full_image"]'
                    );
                    if (fullImgInput) fullImgInput.value = "";

                    const fieldsToClear = [
                        "footer_company_name",
                        "footer_Address",
                        "footer_email",
                        "footer_primary_colour",
                        "footer_secondery_colour",
                        "footer_logo_size",
                        "footer_logo_position",
                        "footer_content_position",
                        "footer_bottom_gap",
                        "footer_right_gap",
                        "footer_top_gap",
                        "footer_left_gap",
                    ];

                    fieldsToClear.forEach((fieldName) => {
                        const input = document.querySelector(`input[name="${fieldName}"]`);
                        if (input) input.value = "";
                    });
                }
                return updated;
            });
            return;
        }

        setFormData((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : type === "file"
                        ? files
                            ? files[0]
                            : null
                        : value,
        }));

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        })

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const quillRef = useRef(null);

    const handlePaddingChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : type === "file"
                        ? files
                            ? files[0]
                            : null
                        : value,
        }));
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        })

    };

    useEffect(() => {
        const fileToBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });

        const saveToLocalStorage = async () => {
            const dataToStore = { ...formData };

            const fileFields = ["header_full_image", "header_logo", "bg_image", "signatory_signature",];

            for (const field of fileFields) {
                if (formData[field] instanceof File) {
                    dataToStore[field] = await fileToBase64(formData[field]);
                }
            }

            localStorage.setItem(
                "LetterTemplateformData",
                JSON.stringify(dataToStore)
            );
        };

        saveToLocalStorage();
    }, [formData]);

    const handleQuillChange = (value, field) => {
        const fixedContent = value.replace(
            /href="(?!http)([^"]+)"/g,
            'href="https://$1"'
        );

        setFormData((prev) => ({
            ...prev,
            [field]: fixedContent,
        }));
    };

    const handleFileClear = (e, fieldName) => {
        e.stopPropagation();
        setFormData({ ...formData, [fieldName]: null });
        document.querySelector(`input[name="${fieldName}"]`).value = "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const uploadData = new FormData();

            Object.entries(formData).forEach(([key, value]) => {
                if (value !== null && value !== undefined) {
                    if (
                        key.endsWith("_logo") ||
                        key.endsWith("_full_image") ||
                        key === "bg_image"
                    ) {
                        uploadData.append(key, value);
                    } else {
                        uploadData.append(key, value);
                    }
                }
            });

            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/letter-builder-template/`,
                    uploadData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200 || res.status === 201) {
                    await getLetterTemplateData();
                    setShow(false);
                    setFormData(initialTemplateData);
                    toast.success("Template created successfully!");
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const isHeaderFieldsDisabled = formData.header_full_image !== null;
    const isFooterFieldsDisabled = formData.footer_full_image !== null;

    return (
        <>
            <button
                title="Add Letter Template"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Letter Template
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Letter Template</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form className="">
                                <div className="form-flex-wrap">
                                    <div className="flex-column ">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Template Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="template_name"
                                            placeholder="Template Name"
                                            value={formData.template_name}
                                            onChange={handleChange}
                                            className={`form-input ${errors.template_name
                                                ? "error"
                                                : inputState.template_name
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        />
                                        {errors.template_name && (
                                            <span className="error-message font-size-text ">
                                                {errors.template_name}
                                            </span>
                                        )}
                                    </div>

                                    {SUPER_ADMIN && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Sub Company<span className="required">*</span>
                                            </label>
                                            <select
                                                name="sub_company"
                                                value={formData.sub_company}
                                                onChange={handleChange}
                                                className={`form-input ${errors.sub_company
                                                    ? "error"
                                                    : inputState.sub_company
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select a Company</option>
                                                {SUB_COMPANIES.map((i, index) => (
                                                    <option key={index} value={i.id}>
                                                        {i.title}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">
                                                    {errors.sub_company}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Page Size<span className="required">*</span>
                                        </label>
                                        <select
                                            name="page_size"
                                            value={formData.page_size}
                                            onChange={handleChange}
                                            className={`form-input ${errors.page_size
                                                ? "error"
                                                : inputState.page_size
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        >
                                            <option value="A4">A4</option>
                                            <option value="A3">A3</option>
                                            <option value="letter">Letter</option>
                                        </select>
                                        {errors.page_size && (
                                            <span className="error-message font-size-text ">
                                                {errors.page_size}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className="flex-row justify-evenly"
                                    style={{ width: "100%" }}
                                >
                                    <div className="flex-row">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                name="header_display"
                                                checked={formData.header_display}
                                                onChange={handleChange}
                                                id="headerDisplay"
                                            />
                                            <label htmlFor={`headerDisplay`}></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                            htmlFor="headerDisplay"
                                            className="font-weight500 font-size-subheading"
                                        >
                                            {formData.header_display ? "Show" : "No"} Header
                                        </label>
                                    </div>
                                    <div className="flex-row">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                name="bg_display"
                                                checked={formData.bg_display}
                                                onChange={handleChange}
                                                id="bgDisplay"
                                            />
                                            <label htmlFor={`bgDisplay`}></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                            htmlFor="bgDisplay"
                                            className="font-weight500 font-size-subheading"
                                        >
                                            {formData.bg_display ? "Show" : "No"} Background
                                        </label>
                                    </div>
                                    <div className="flex-row">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                name="signatory_display"
                                                checked={formData.signatory_display}
                                                onChange={handleChange}
                                                id="signatureAuthority"
                                            />
                                            <label htmlFor={`signatureAuthority`}></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                            htmlFor="signatureAuthority"
                                            className="font-weight500 font-size-subheading"
                                        >
                                            {formData.signatory_display ? "Show" : "No"} Signature
                                        </label>
                                    </div>
                                    <div className="flex-row">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                name="footer_display"
                                                checked={formData.footer_display}
                                                onChange={handleChange}
                                                id="footerDisplay"
                                            />
                                            <label htmlFor={`footerDisplay`}></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                            htmlFor="footerDisplay"
                                            className="font-weight500 font-size-subheading"
                                        >
                                            {formData.footer_display ? "Show" : "No"} Footer
                                        </label>
                                    </div>
                                </div>

                                {/* Header Section */}
                                {formData.header_display && (
                                    <div className="">
                                        <div className="jd-heading-outer heading-bg-color-white">
                                            <div className="jd-heading-outer-flex">
                                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                                    Header
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="jd-heading-bottom-bold"></div>
                                                <div className="jd-heading-bottom-light"></div>
                                            </div>
                                        </div>
                                        <div className="form-flex-wrap">
                                            {!(
                                                formData.header_logo ||
                                                formData.header_company_name ||
                                                formData.header_email
                                            ) && (
                                                    <>
                                                        <div className="flex-column">
                                                            <label className="form-label">
                                                                Header Full Image (will override other footer
                                                                elements)
                                                            </label>
                                                            <div
                                                                className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo
                                                                    ? "error"
                                                                    : inputState.company_logo
                                                                        ? "success"
                                                                        : ""
                                                                    }`}
                                                            >
                                                                <label
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        width: "29vw",
                                                                    }}
                                                                    htmlFor="header_full_image"
                                                                >
                                                                    <CloudUpload />

                                                                    <span
                                                                        className="truncate-url"
                                                                        style={{ marginLeft: "20px" }}
                                                                    >
                                                                        {formData.header_full_image
                                                                            ? formData.header_full_image.name
                                                                            : "No file selected"}
                                                                    </span>
                                                                </label>
                                                                <input
                                                                    type="file"
                                                                    id="header_full_image"
                                                                    name="header_full_image"
                                                                    accept=".png , image/*"
                                                                    onChange={handleChange}
                                                                    style={{
                                                                        display: "none",
                                                                        position: "relative",
                                                                    }}
                                                                    disabled={isHeaderFieldsDisabled}
                                                                />
                                                                {formData?.header_full_image && (
                                                                    <span
                                                                        className="file-clear"
                                                                        onClick={(e) =>
                                                                            handleFileClear(e, "header_full_image")
                                                                        }
                                                                    >
                                                                        Clear
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                            {!formData.header_full_image && (
                                                <>
                                                    <div className="flex-column">
                                                        <label className="form-label">Header Logo</label>
                                                        <div
                                                            className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo
                                                                ? "error"
                                                                : inputState.company_logo
                                                                    ? "success"
                                                                    : ""
                                                                }`}
                                                        >
                                                            <label
                                                                style={{
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    width: "29vw",
                                                                }}
                                                                htmlFor="header_logo"
                                                            >
                                                                <CloudUpload />
                                                                <span
                                                                    className=" truncate-url"
                                                                    style={{ marginLeft: "20px" }}
                                                                >
                                                                    {formData.header_logo
                                                                        ? formData.header_logo.name
                                                                        : "No file selected"}
                                                                </span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                id="header_logo"
                                                                name="header_logo"
                                                                accept=".png , image/*"
                                                                onChange={handleChange}
                                                                // disabled={isHeaderLogoFieldDisabled}
                                                                style={{
                                                                    display: "none",
                                                                    position: "relative",
                                                                }}
                                                            />
                                                            {formData.header_logo && (
                                                                <span
                                                                    className="file-clear"
                                                                    onClick={(e) =>
                                                                        handleFileClear(e, "header_logo")
                                                                    }
                                                                >
                                                                    Clear
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="flex-column">
                                                        <div className="flex-column">
                                                            <label className="form-label">Company Name</label>
                                                            <input
                                                                type="text"
                                                                name="header_company_name"
                                                                value={formData.header_company_name}
                                                                onChange={handleChange}
                                                                className="file-in-upload"
                                                            />
                                                        </div>
                                                        <div className="flex-column">
                                                            <label className="form-label">Email</label>
                                                            <input
                                                                type="email"
                                                                name="header_email"
                                                                value={formData.header_email}
                                                                onChange={handleChange}
                                                                className="file-in-upload"
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className="flex-column">
                                                        <label className="form-label">Address</label>
                                                        <TipTapEditor
                                                            ref={quillRef}
                                                            value={formData.header_Address}
                                                            onChange={(value) => handleQuillChange(value, "header_Address")}
                                                            style={{ width: '34vw', minHeight: '170px' }}
                                                            className="form-input-quill"
                                                        />
                                                    </div>



                                                    <div className="flex-column">
                                                        <label className="form-label">Primary Color</label>
                                                        <input
                                                            type="color"
                                                            name="header_primary_colour"
                                                            value={formData.header_primary_colour}
                                                            onChange={handleChange}
                                                            className="form-control form-control-color"
                                                        />
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Secondary Color
                                                        </label>
                                                        <input
                                                            type="color"
                                                            name="header_secondery_colour"
                                                            value={formData.header_secondery_colour}
                                                            onChange={handleChange}
                                                            className="form-control form-control-color"
                                                        />
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Logo Height (%)
                                                        </label>
                                                        <input
                                                            type="range"
                                                            name="header_logo_size"
                                                            min="10"
                                                            max="100"
                                                            value={formData.header_logo_size || 100}
                                                            onChange={handleChange}
                                                            className="form-range"
                                                        />
                                                        <span>{formData.header_logo_size || 100}%</span>
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">Logo Position</label>
                                                        <select
                                                            name="header_logo_position"
                                                            value={formData.header_logo_position}
                                                            onChange={handleChange}
                                                            className="form-input-date"
                                                            style={{ width: '14vw' }}
                                                        >
                                                            <option value="left">Left</option>
                                                            <option value="right">Right</option>
                                                            <option value="center">Center</option>
                                                        </select>
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Content Position
                                                        </label>
                                                        <select
                                                            name="header_content_position"
                                                            value={formData.header_content_position}
                                                            onChange={handleChange}
                                                            className="form-input-date"
                                                            style={{ width: '14vw' }}
                                                        >
                                                            <option value="left">Left</option>
                                                            <option value="right">Right</option>
                                                            <option value="center">Center</option>
                                                        </select>
                                                    </div>
                                                </>
                                            )}

                                            <div className="flex-column">
                                                <label className="form-label">Padding Left</label>
                                                <input
                                                    type="number"
                                                    name="header_left_gap"
                                                    value={formData?.header_left_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Right</label>
                                                <input
                                                    type="number"
                                                    name="header_right_gap"
                                                    value={formData?.header_right_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Top</label>
                                                <input
                                                    type="number"
                                                    name="header_top_gap"
                                                    value={formData?.header_top_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Bottom</label>
                                                <input
                                                    type="number"
                                                    name="header_bottom_gap"
                                                    value={formData?.header_bottom_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Background Image Section */}
                                {formData.bg_display && (
                                    <>
                                        <div className="jd-heading-outer heading-bg-color-white">
                                            <div className="jd-heading-outer-flex">
                                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                                    Background Image
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="jd-heading-bottom-bold"></div>
                                                <div className="jd-heading-bottom-light"></div>
                                            </div>
                                        </div>
                                        <div className="form-flex-wrap">
                                            <div className="flex-column">
                                                <label className="form-label">Background Image</label>
                                                <div
                                                    className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo
                                                        ? "error"
                                                        : inputState.company_logo
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                >
                                                    <label
                                                        style={{
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            width: "29vw",
                                                        }}
                                                        htmlFor="bg_image"
                                                    >
                                                        <CloudUpload />
                                                        <span
                                                            className=" truncate-url"
                                                            style={{ marginLeft: "20px" }}
                                                        >
                                                            {formData.bg_image
                                                                ? formData.bg_image.name
                                                                : "No file selected"}
                                                        </span>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        id="bg_image"
                                                        name="bg_image"
                                                        accept=".png , image/*"
                                                        onChange={handleChange}
                                                        style={{ display: "none", position: "relative" }}
                                                    />
                                                    {formData.bg_image && (
                                                        <span
                                                            className="file-clear"
                                                            onClick={(e) => handleFileClear(e, "bg_image")}
                                                        >
                                                            Clear
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Image Rotation</label>
                                                <input
                                                    type="number"
                                                    name="bg_angle"
                                                    min={-180}
                                                    max={180}
                                                    placeholder="-180 to 180"
                                                    onChange={handleChange}
                                                    className="form-input"
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Left</label>
                                                <input
                                                    type="number"
                                                    name="content_left_gap"
                                                    value={formData.content_left_gap}
                                                    onChange={handleChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>

                                            <div className="flex-column">
                                                <label className="form-label">Padding Right</label>
                                                <input
                                                    type="number"
                                                    name="content_right_gap"
                                                    value={formData.content_right_gap}
                                                    onChange={handleChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>

                                            <div className="flex-column">
                                                <label className="form-label">Size (%)</label>
                                                <input
                                                    type="range"
                                                    name="bg_size"
                                                    min="10"
                                                    max="100"
                                                    value={formData.bg_size || 100}
                                                    onChange={handleChange}
                                                    className="form-range"
                                                    style={{ width: '14vw' }}
                                                />
                                                <span>{formData.bg_size || 100}%</span>
                                            </div>

                                            <div className="flex-column">
                                                <label className="form-label">Opacity (%)</label>
                                                <input
                                                    type="range"
                                                    name="bg_opacity"
                                                    min="1"
                                                    max="100"
                                                    value={formData.bg_opacity || 20}
                                                    onChange={handleChange}
                                                    className="form-range"
                                                    style={{ width: '14vw' }}
                                                />
                                                <span>{formData.bg_opacity || 20}%</span>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* Signature Section */}

                                {formData.signatory_display && (
                                    <div className="">
                                        <div className="jd-heading-outer heading-bg-color-white">
                                            <div className="jd-heading-outer-flex">
                                                <h2 className="jd-heading-main font-weight600 font-size-heading">
                                                    Signature Configuration
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="jd-heading-bottom-bold"></div>
                                                <div className="jd-heading-bottom-light"></div>
                                            </div>
                                        </div>

                                        <div className="form-flex-wrap">
                                            {/* Sign Heading */}
                                            <div className="flex-column">
                                                <label className="form-label">Signature Heading<span className="required">*</span></label>
                                                <input
                                                    type="text"
                                                    name="signatory_sign_heading"
                                                    value={formData.signatory_sign_heading || ""}
                                                    onChange={handleChange}
                                                    className="file-in-upload"
                                                    placeholder="Heading"
                                                    style={{ marginBottom: '10px' }}
                                                />
                                                {isSubmitted && errors.signatory_sign_heading && (
                                                    <span className="error-message font-size-text ">{errors.signatory_sign_heading}</span>
                                                )}

                                            </div>

                                            {/* Name */}
                                            <div className="flex-column">
                                                <label className="form-label">Signatory Name</label>
                                                <input
                                                    type="text"
                                                    name="signatory_name"
                                                    value={formData.signatory_name || ""}
                                                    onChange={handleChange}
                                                    className="file-in-upload"
                                                    placeholder="Name"
                                                />
                                            </div>

                                            {/* Designation */}
                                            <div className="flex-column">
                                                <label className="form-label">Designation</label>
                                                <input
                                                    type="text"
                                                    name="signatory_designation"
                                                    value={formData.signatory_designation || ""}
                                                    onChange={handleChange}
                                                    className="file-in-upload"
                                                    placeholder="Designation"
                                                />
                                            </div>

                                            {/* Signature Upload */}
                                            <div className="flex-column">
                                                <label className="form-label">Signature Image<span className="required">*</span></label>
                                                <div className="file-upload-container flex-row justify-between file-in-upload" >
                                                    <label
                                                        htmlFor="signatory_signature"
                                                        style={{
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            width: "29vw",
                                                        }}
                                                    >
                                                        <CloudUpload />
                                                        <span className="truncate-url" style={{ marginLeft: "20px" }}>
                                                            {formData.signatory_signature
                                                                ? formData.signatory_signature.name
                                                                : "No file selected"}
                                                        </span>
                                                    </label>

                                                    <input
                                                        type="file"
                                                        id="signatory_signature"
                                                        name="signatory_signature"
                                                        accept="image/*"
                                                        onChange={handleChange}
                                                        style={{ display: "none" }}
                                                    />

                                                    {formData.signatory_signature && (
                                                        <span
                                                            className="file-clear"
                                                            onClick={(e) =>
                                                                handleFileClear(e, "signatory_signature")
                                                            }
                                                        >
                                                            Clear
                                                        </span>
                                                    )}
                                                </div>
                                                {isSubmitted && errors.signatory_signature && (
                                                    <span className="error-message font-size-text ">{errors.signatory_signature}</span>
                                                )}

                                            </div>





                                            <div className="form-flex-wrap" style={{ gap: '37px' }}>
                                                {/* Content Position */}
                                                <div className="flex-column">
                                                    <label className="form-label">Content Alignment</label>
                                                    <select
                                                        name="signatory_content_position"
                                                        value={formData.signatory_content_position || "left"}
                                                        onChange={handleChange}
                                                        className="form-input"
                                                        style={{ width: '15vw' }}
                                                    >
                                                        <option value="left">Left</option>
                                                        <option value="center">Center</option>
                                                        <option value="right">Right</option>
                                                    </select>
                                                </div>

                                                {/* Signature Position */}
                                                <div className="flex-column">
                                                    <label className="form-label">Signature Image Position</label>
                                                    <select
                                                        name="signatory_sign_position"
                                                        value={formData.signatory_sign_position || "left"}
                                                        onChange={handleChange}
                                                        className="form-input"
                                                        style={{ width: '15vw' }}
                                                    >
                                                        <option value="left">Left</option>
                                                        <option value="center">Center</option>
                                                        <option value="right">Right</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-flex-wrap" style={{ gap: '37px' }}>
                                                {/* Overall Position */}
                                                <div className="flex-column">
                                                    <label className="form-label">Overall Position(in row)</label>
                                                    <select
                                                        name="signatory_overall_position"
                                                        value={formData.signatory_overall_position || "left"}
                                                        onChange={handleChange}
                                                        className="form-input"
                                                        style={{ width: '15vw' }}
                                                    >
                                                        <option value="left">Left</option>
                                                        <option value="center">Center</option>
                                                        <option value="right">Right</option>
                                                    </select>
                                                </div>

                                                {/* Overall Position */}
                                                <div className="flex-column">
                                                    <label className="form-label">Overall Placement</label>
                                                    <select
                                                        name="signatory_overall_placement"
                                                        value={formData.signatory_overall_placement || "End"}
                                                        onChange={handleChange}
                                                        className="form-input"
                                                        style={{ width: '15vw' }}
                                                    >
                                                        <option value="Start">Before Content</option>
                                                        <option value="End">After Content</option>
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Signature Size */}
                                            <div className="form-flex-wrap">
                                                <div className="flex-column">
                                                    <label className="form-label">Signature Size (%)</label>
                                                    <input
                                                        type="range"
                                                        name="signatory_sign_size"
                                                        min="30"
                                                        max="200"
                                                        value={formData.signatory_sign_size || 100}
                                                        onChange={handleChange}
                                                        className="form-range"
                                                        style={{ width: '35.5vw' }}

                                                    />
                                                    <span>{formData.signatory_sign_size || 100}%</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                )}

                                {/* Footer Section */}
                                {formData.footer_display && (
                                    <div className="">
                                        <div className="jd-heading-outer heading-bg-color-white">
                                            <div className="jd-heading-outer-flex">
                                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                                    Footer Configuration
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="jd-heading-bottom-bold"></div>
                                                <div className="jd-heading-bottom-light"></div>
                                            </div>
                                        </div>
                                        <div className="form-flex-wrap">
                                            {!(
                                                formData.footer_logo ||
                                                formData.footer_company_name ||
                                                formData.footer_email
                                            ) && (
                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Footer Full Image (will override other footer
                                                            elements)
                                                        </label>
                                                        <div
                                                            className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo
                                                                ? "error"
                                                                : inputState.company_logo
                                                                    ? "success"
                                                                    : ""
                                                                }`}
                                                        >
                                                            <label
                                                                style={{
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    width: "29vw",
                                                                }}
                                                                htmlFor="footer_full_image"
                                                            >
                                                                <CloudUpload />
                                                                <span
                                                                    className="truncate-url"
                                                                    style={{ marginLeft: "20px" }}
                                                                >
                                                                    {formData.footer_full_image
                                                                        ? formData.footer_full_image.name
                                                                        : "No file selected"}
                                                                </span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                id="footer_full_image"
                                                                name="footer_full_image"
                                                                accept=".png , image/*"
                                                                onChange={handleChange}
                                                                style={{ display: "none", position: "relative" }}
                                                                disabled={isFooterFieldsDisabled}
                                                            />
                                                            {formData.footer_full_image && (
                                                                <span
                                                                    className="file-clear"
                                                                    onClick={(e) =>
                                                                        handleFileClear(e, "footer_full_image")
                                                                    }
                                                                >
                                                                    Clear
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            {!formData.footer_full_image && (
                                                <>
                                                    <div className="flex-column">
                                                        <label className="form-label">Footer Logo</label>
                                                        <div
                                                            className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo
                                                                ? "error"
                                                                : inputState.company_logo
                                                                    ? "success"
                                                                    : ""
                                                                }`}
                                                        >
                                                            <label
                                                                style={{
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    width: "29vw",
                                                                }}
                                                                htmlFor="footer_logo"
                                                            >
                                                                <CloudUpload />
                                                                <span
                                                                    className=" truncate-url"
                                                                    style={{ marginLeft: "20px" }}
                                                                >
                                                                    {formData.footer_logo
                                                                        ? formData.footer_logo.name
                                                                        : "No file selected"}
                                                                </span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                id="footer_logo"
                                                                name="footer_logo"
                                                                accept=".png , image/*"
                                                                onChange={handleChange}
                                                                style={{
                                                                    display: "none",
                                                                    position: "relative",
                                                                }}
                                                            />
                                                            {formData.footer_logo && (
                                                                <span
                                                                    className="file-clear"
                                                                    onClick={(e) =>
                                                                        handleFileClear(e, "footer_logo")
                                                                    }
                                                                >
                                                                    Clear
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="flex-column" >
                                                        <div className="flex-column">
                                                            <label className="form-label">Company Name</label>
                                                            <input
                                                                type="text"
                                                                name="footer_company_name"
                                                                value={formData.footer_company_name}
                                                                onChange={handleChange}
                                                                className="file-in-upload"
                                                            />
                                                        </div>

                                                        <div className="flex-column">
                                                            <label className="form-label">Email</label>
                                                            <input
                                                                type="email"
                                                                name="footer_email"
                                                                value={formData.footer_email}
                                                                onChange={handleChange}
                                                                className="file-in-upload"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="flex-column">
                                                        <label className="form-label">Address</label>
                                                        <TipTapEditor
                                                            ref={quillRef}
                                                            value={formData.footer_Address}
                                                            onChange={(value) => handleQuillChange(value, "footer_Address")}
                                                            style={{ width: '34vw', minHeight: '170px' }}
                                                            className="form-input-quill"
                                                        />
                                                    </div>



                                                    <div className="flex-column">
                                                        <label className="form-label">Primary Color</label>
                                                        <input
                                                            type="color"
                                                            name="footer_primary_colour"
                                                            value={formData.footer_primary_colour}
                                                            onChange={handleChange}
                                                            className="form-control form-control-color"
                                                        />
                                                    </div>
                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Secondary Color
                                                        </label>
                                                        <input
                                                            type="color"
                                                            name="footer_secondery_colour"
                                                            value={formData.footer_secondery_colour}
                                                            onChange={handleChange}
                                                            className="form-control form-control-color"
                                                        />
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Logo Height (%)
                                                        </label>
                                                        <input
                                                            type="range"
                                                            name="footer_logo_size"
                                                            min="10"
                                                            max="100"
                                                            value={formData.footer_logo_size || 100}
                                                            onChange={handleChange}
                                                            className="form-range"
                                                        />
                                                        <span>{formData.footer_logo_size || 100}%</span>
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">Logo Position</label>
                                                        <select
                                                            name="footer_logo_position"
                                                            value={formData.footer_logo_position}
                                                            onChange={handleChange}
                                                            className="form-input-date"
                                                            style={{ width: '14vw' }}
                                                        >
                                                            <option value="left">Left</option>
                                                            <option value="right">Right</option>
                                                            <option value="center">Center</option>
                                                        </select>
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Content Position
                                                        </label>
                                                        <select
                                                            name="footer_content_position"
                                                            value={formData.footer_content_position}
                                                            onChange={handleChange}
                                                            className="form-input-date"
                                                            style={{ width: '14vw' }}
                                                        >
                                                            <option value="left">Left</option>
                                                            <option value="right">Right</option>
                                                            <option value="center">Center</option>
                                                        </select>
                                                    </div>
                                                </>
                                            )}

                                            <div className="flex-column">
                                                <label className="form-label">Padding Left</label>
                                                <input
                                                    type="number"
                                                    name="footer_left_gap"
                                                    value={formData.footer_left_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Right</label>
                                                <input
                                                    type="number"
                                                    name="footer_right_gap"
                                                    value={formData.footer_right_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Top</label>
                                                <input
                                                    type="number"
                                                    name="footer_top_gap"
                                                    value={formData.footer_top_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Bottom</label>
                                                <input
                                                    type="number"
                                                    name="footer_bottom_gap"
                                                    value={formData.footer_bottom_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </form>

                            <div className="button-models">
                                <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}
                                >
                                    Cancel
                                </button>

                                <ViewLetterBuilder templateData={formData} />
                                <button
                                    type="submit"
                                    className="model-button model-button-leave font-weight500 font-size-heading"
                                    disabled={loading}
                                    onClick={handleSubmit}
                                >
                                    {loading ? "Creating..." : "Create Template"}
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                </Modal.Body >
            </Modal >

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

const LetterUpdate = ({
    i,
    SUPER_ADMIN,
    SUB_COMPANIES,
    getLetterTemplateData,
}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [previewShow, setPreviewShow] = useState(false);
    const [letterTemp, setLetterTemp] = useState(i);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [variableConfirmation, setVariableConfirmation] = useState(false);
    // const handleClose = () => {
    //   setShow(false);
    //   setPreviewShow(false);
    // };
    const handleClose = () => {
        setShow(false);
        setPreviewShow(false);

        // 🔥 Reset unsaved changes
        if (originalLetterTemp) {
            setLetterTemp(originalLetterTemp);
        }

        // optional cleanup
        setErrors({});
        setInputState({});
    };

    const handleShow = () => {
        setShow(true);

        // 🔥 Always load fresh original data
        if (originalLetterTemp) {
            setLetterTemp(originalLetterTemp);
        }
    };

    // const handleShow = () => setShow(true);

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [originalLetterTemp, setOriginalLetterTemp] = useState(null);

    // useEffect(() => {
    //   if (letterTemp?.id) {
    //     setOriginalLetterTemp(letterTemp);
    //   }
    // }, [letterTemp]);
    useEffect(() => {
        if (i?.id) {
            setLetterTemp(i);          // editable data
            setOriginalLetterTemp(i);  // original data (unchanged)
        }
    }, [i]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (name === "header_full_image" && files && files[0]) {
            setLetterTemp((prev) => ({
                ...prev,
                header_full_image: files[0],
                header_logo: null,
                header_company_name: "",
                header_Address: "",
                header_email: "",
                header_primary_colour: "",
                header_secondery_colour: "",
                header_left_gap: "",
                header_bottom_gap: "",
                header_right_gap: "",
                header_top_gap: "",
            }));
            document.querySelector(`input[name="header_logo"]`).value = "";

            return;
        }
        if (name === "bg_image" && files && files[0]) {
            setLetterTemp((prev) => ({
                ...prev,
                bg_image: files[0],
            }));
            // document.querySelector(`input[name="bg_image"]`).value = "";

            return;
        }

        if (
            name.startsWith("header_") &&
            name !== "header_full_image" &&
            letterTemp.header_full_image
        ) {
            setLetterTemp((prev) => ({
                ...prev,
                header_full_image: null,
            }));
            document.querySelector(`input[name="header_full_image"]`).value = "";
        }

        if (name === "footer_full_image" && files && files[0]) {
            setLetterTemp((prev) => ({
                ...prev,
                footer_full_image: files[0],
                footer_logo: null,
                footer_company_name: "",
                footer_Address: "",
                footer_email: "",
                footer_primary_colour: "",
                footer_secondery_colour: "",
                footer_left_gap: "",
                footer_bottom_gap: "",
                footer_right_gap: "",
                footer_top_gap: "",
            }));
            document.querySelector(`input[name="footer_logo"]`).value = "";
            return;
        }

        if (
            name.startsWith("footer_") &&
            name !== "footer_full_image" &&
            letterTemp.footer_full_image
        ) {
            setLetterTemp((prev) => ({
                ...prev,
                footer_full_image: null,
            }));
            document.querySelector(`input[name="footer_full_image"]`).value = "";
        }

        if (name === "header_display") {
            setLetterTemp((prev) => {
                const updated = {
                    ...prev,
                    header_display: checked,
                };
                if (!checked) {
                    updated.header_logo = null;
                    updated.header_full_image = null;
                    updated.header_company_name = null;
                    updated.header_Address = null;
                    updated.header_email = null;
                    updated.header_primary_colour = null;
                    updated.header_secondery_colour = null;
                    updated.header_logo_size = null;
                    updated.header_logo_position = null;
                    updated.header_content_position = null;
                    updated.header_bottom_gap = null;
                    updated.header_right_gap = null;
                    updated.header_top_gap = null;
                    updated.header_left_gap = null;
                    updated.header_display = false;

                    const logoInput = document.querySelector('input[name="header_logo"]');
                    if (logoInput) logoInput.value = "";

                    const fullImgInput = document.querySelector(
                        'input[name="header_full_image"]'
                    );
                    if (fullImgInput) fullImgInput.value = "";

                    const header_displayInput = document.querySelector(
                        'input[name="header_display"]'
                    );
                    if (header_displayInput) header_displayInput.value = false;

                    const fieldsToClear = [
                        "header_company_name",
                        "header_Address",
                        "header_email",
                        "header_primary_colour",
                        "header_secondery_colour",
                        "header_logo_size",
                        "header_logo_position",
                        "header_content_position",
                        "header_bottom_gap",
                        "header_right_gap",
                        "header_top_gap",
                        "header_left_gap",
                    ];

                    fieldsToClear.forEach((fieldName) => {
                        const input = document.querySelector(`input[name="${fieldName}"]`);
                        if (input) input.value = "";
                    });
                }
                return updated;
            });
            return;
        }

        if (name === "bg_display") {
            setLetterTemp((prev) => {
                const updated = {
                    ...prev,
                    bg_display: checked,
                };
                if (!checked) {
                    updated.bg_image = null;
                    updated.bg_angle = null;
                    updated.content_left_gap = null;
                    updated.content_right_gap = null;
                    updated.bg_size = null;
                    updated.bg_opacity = null;
                    updated.bg_display = false;

                    const bgInput = document.querySelector('input[name="bg_image"]');
                    if (bgInput) bgInput.value = "";

                    const bgDisplayInput = document.querySelector(
                        'input[name="bg_display"]'
                    );
                    if (bgDisplayInput) bgDisplayInput.value = false;

                    const fieldsToClear = [
                        "bg_angle",
                        "content_left_gap",
                        "content_right_gap",
                        "bg_size",
                        "bg_opacity",
                    ];

                    fieldsToClear.forEach((fieldName) => {
                        const input = document.querySelector(`input[name="${fieldName}"]`);
                        if (input) input.value = "";
                    });
                }
                return updated;
            });
            return;
        }

        if (name === "signatory_display") {
            setLetterTemp((prev) => {
                const updated = {
                    ...prev,
                    signatory_display: checked,
                };

                if (!checked) {
                    updated.signatory_content_position = null;
                    updated.signatory_name = null;
                    updated.signatory_designation = null;
                    updated.signatory_sign_heading = null;
                    updated.signatory_signature = null;
                    updated.signatory_overall_position = null;
                    updated.signatory_sign_position = null;
                    updated.signatory_sign_size = null;
                    updated.signatory_overall_placement = null;

                    // clear signature file input
                    const signatureInput = document.querySelector(
                        'input[name="signatory_signature"]'
                    );
                    if (signatureInput) signatureInput.value = "";

                    const fieldsToClear = [
                        "signatory_content_position",
                        "signatory_name",
                        "signatory_designation",
                        "signatory_sign_heading",
                        "signatory_sign_size",
                    ];

                    fieldsToClear.forEach((fieldName) => {
                        const input = document.querySelector(`input[name="${fieldName}"]`);
                        if (input) input.value = "";
                    });
                }
                if (checked) {
                    updated.signatory_content_position ||= "left";
                    updated.signatory_sign_position ||= "left";
                    updated.signatory_overall_position ||= "left";
                    updated.signatory_sign_size ||= 100;
                    updated.signatory_overall_placement ||= "End";
                }


                return updated;
            });
            return;
        }

        if (name === "footer_display") {
            setLetterTemp((prev) => {
                const updated = {
                    ...prev,
                    footer_display: checked,
                };
                if (!checked) {
                    updated.footer_logo = null;
                    updated.footer_full_image = null;
                    updated.footer_company_name = null;
                    updated.footer_Address = null;
                    updated.footer_email = null;
                    updated.footer_primary_colour = null;
                    updated.footer_secondery_colour = null;
                    updated.footer_logo_size = null;
                    updated.footer_logo_position = null;
                    updated.footer_content_position = null;
                    updated.footer_bottom_gap = null;
                    updated.footer_right_gap = null;
                    updated.footer_top_gap = null;
                    updated.footer_left_gap = null;
                    updated.footer_display = false;

                    const logoInput = document.querySelector('input[name="footer_logo"]');
                    if (logoInput) logoInput.value = "";
                    const fullImgInput = document.querySelector(
                        'input[name="footer_full_image"]'
                    );
                    if (fullImgInput) fullImgInput.value = "";

                    const footer_displayInput = document.querySelector(
                        'input[name="footer_display"]'
                    );
                    if (footer_displayInput) footer_displayInput.value = false;

                    const fieldsToClear = [
                        "footer_company_name",
                        "footer_Address",
                        "footer_email",
                        "footer_primary_colour",
                        "footer_secondery_colour",
                        "footer_logo_size",
                        "footer_logo_position",
                        "footer_content_position",
                        "footer_bottom_gap",
                        "footer_right_gap",
                        "footer_top_gap",
                        "footer_left_gap",
                    ];

                    fieldsToClear.forEach((fieldName) => {
                        const input = document.querySelector(`input[name="${fieldName}"]`);
                        if (input) input.value = "";
                    });
                }
                return updated;
            });
            return;
        }

        setLetterTemp((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : type === "file"
                        ? files
                            ? files[0]
                            : null
                        : value,
        }));
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        })

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const isHeaderFieldsDisabled = letterTemp.header_full_image !== null;
    const isFooterFieldsDisabled = letterTemp.footer_full_image !== null;

    const handlePaddingChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        setLetterTemp((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : type === "file"
                        ? files
                            ? files[0]
                            : null
                        : value,
        }));
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        })
    };

    const handleFileClear = (e, fieldName) => {
        setLetterTemp((prevLetterTemp) => ({
            ...prevLetterTemp,
            [fieldName]: null,
        }));

        if (e.target.type === "file") {
            e.target.value = null;
        }

        e.stopPropagation();
    };

    const handleQuillChange = (value, field) => {
        setLetterTemp((prev) => ({
            ...prev,
            [field]: value,
        }));
        if (isSubmitted && value.trim() !== '') {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors.company_address;
                return newErrors;
            });

            setInputState((prev) => ({
                ...prev,
                company_address: true,
            }));
        }
    };

    // const validateForm = () => {
    //   const newErrors = {};
    //   const requiredFields = ["template_name", "sub_company", "page_size"];
    //   requiredFields.forEach((field) => {
    //     if (!letterTemp[field]) {
    //       newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
    //         } is required !`;
    //     }
    //   });

    //   setErrors(newErrors);
    //   setIsSubmitted(true);
    //   return Object.keys(newErrors).length === 0;
    // };

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = ["template_name", "sub_company", "page_size"];

        requiredFields.forEach((field) => {
            if (!letterTemp[field]) {
                newErrors[field] =
                    `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });


        if (letterTemp.signatory_display) {
            if (!letterTemp.signatory_sign_heading?.trim()) {
                newErrors.signatory_sign_heading = "Signature heading is required!";
            }

            if (!letterTemp.signatory_signature) {
                newErrors.signatory_signature = "Signature image is required!";
            }
        }

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);
            const uploadData = new FormData();

            Object.entries(letterTemp).forEach(([key, value]) => {
                const isFileField =
                    key.endsWith("_logo") ||
                    key.endsWith("_full_image") ||
                    key === "bg_image" ||
                    key === "signatory_signature";

                // const isUpdatedFile =
                //   value instanceof File ||
                //   value === null ||
                //   !originalLetterTemp ||
                //   originalLetterTemp[key] !== value;

                // if (isFileField) {
                //   if (isUpdatedFile) {
                //     // For bg_image, handle the null case
                //     if (key === "bg_image" && value === null) {
                //       uploadData.append(key, ""); // Send an empty string instead of null
                //     } else {
                //       uploadData.append(key, value === null ? "" : value);
                //     }
                //   }
                // } else {
                //   if (value !== null && value !== undefined) {
                //     uploadData.append(key, value);
                //   }
                // }
                if (isFileField) {

                    if (value instanceof File) {
                        uploadData.append(key, value);
                    }

                    else if (value === null) {
                        uploadData.append(key, "");
                    }

                    return;
                }
                if (value !== null && value !== undefined) {
                    uploadData.append(key, value);
                }
            });

            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                let res;
                if (letterTemp?.id) {
                    res = await axios.put(
                        `${BASE_URL}/wfm/letter-builder-template-update-delete/${letterTemp?.id}/`,
                        uploadData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    );
                }

                if (res.status === 200) {
                    await getLetterTemplateData();
                    setShow(false);
                    toast.success("Template updated successfully!");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            {i?.id && (
                <button
                    title="Update Letter Template"
                    className="model-edit-button-ml"
                    onClick={handleShow}
                >
                    <UpdatePencil />
                </button>
            )}
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Update Letter Template -{" "}
                        <span className="dynamic-modal-title">
                            {" "}
                            {letterTemp.template_name}{" "}
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form className="">
                                <div className="form-flex-wrap">
                                    <div className="flex-column ">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Template Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="template_name"
                                            placeholder="Template Name"
                                            value={letterTemp.template_name}
                                            onChange={handleChange}
                                            className={`form-input ${errors.template_name
                                                ? "error"
                                                : inputState.template_name
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        />
                                        {errors.template_name && (
                                            <span className="error-message font-size-text ">
                                                {errors.template_name}
                                            </span>
                                        )}
                                    </div>

                                    {SUPER_ADMIN && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Sub Company<span className="required">*</span>
                                            </label>
                                            <select
                                                name="sub_company"
                                                value={letterTemp.sub_company}
                                                onChange={handleChange}
                                                className={`form-input ${errors.sub_company
                                                    ? "error"
                                                    : inputState.sub_company
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select a Company</option>
                                                {SUB_COMPANIES.map((i, index) => (
                                                    <option key={index} value={i.id}>
                                                        {i.title}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">
                                                    {errors.sub_company}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Page Size<span className="required">*</span>
                                        </label>
                                        <select
                                            name="page_size"
                                            value={letterTemp.page_size}
                                            onChange={handleChange}
                                            // onChange={(e) => setPageSize(e.target.value)}
                                            className={`form-input ${errors.page_size
                                                ? "error"
                                                : inputState.page_size
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        >
                                            <option value="A4">A4</option>
                                            <option value="A3">A3</option>
                                            <option value="letter">Letter</option>
                                        </select>
                                        {errors.page_size && (
                                            <span className="error-message font-size-text ">
                                                {errors.page_size}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className="flex-row justify-evenly"
                                    style={{ width: "100%" }}
                                >
                                    <div className="flex-row">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                name="header_display"
                                                checked={letterTemp.header_display}
                                                onChange={handleChange}
                                                id="headerDisplay"
                                            />
                                            <label htmlFor={`headerDisplay`}></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                            htmlFor="headerDisplay"
                                            className="font-weight500 font-size-subheading"
                                        >
                                            {letterTemp.header_display ? "Show" : "No"} Header
                                        </label>
                                    </div>
                                    <div className="flex-row">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                name="bg_display"
                                                checked={letterTemp.bg_display}
                                                onChange={handleChange}
                                                id="bgDisplay"
                                            />
                                            <label htmlFor={`bgDisplay`}></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                            htmlFor="bgDisplay"
                                            className="font-weight500 font-size-subheading"
                                        >
                                            {letterTemp.header_display ? "Show" : "No"} Background
                                        </label>
                                    </div>
                                    <div className="flex-row">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                name="signatory_display"
                                                checked={letterTemp.signatory_display}
                                                onChange={handleChange}
                                                id="signatureAuthority"
                                            />
                                            <label htmlFor={`signatureAuthority`}></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                            htmlFor="signatureAuthority"
                                            className="font-weight500 font-size-subheading"
                                        >
                                            {letterTemp.signatory_display ? "Show" : "No"} Signature
                                        </label>
                                    </div>
                                    <div className="flex-row">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                name="footer_display"
                                                checked={letterTemp.footer_display}
                                                onChange={handleChange}
                                                id="footerDisplay"
                                            />
                                            <label htmlFor={`footerDisplay`}></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                            htmlFor="footerDisplay"
                                            className="font-weight500 font-size-subheading"
                                        >
                                            {letterTemp.footer_display ? "Show" : "No"} Footer
                                        </label>
                                    </div>
                                </div>

                                {/* Header Section */}
                                {letterTemp.header_display && (
                                    <div className="">
                                        <div className="jd-heading-outer heading-bg-color-white">
                                            <div className="jd-heading-outer-flex">
                                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                                    Header Configuration
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="jd-heading-bottom-bold"></div>
                                                <div className="jd-heading-bottom-light"></div>
                                            </div>
                                        </div>
                                        <div className="form-flex-wrap">
                                            {!(
                                                letterTemp.header_logo ||
                                                letterTemp.header_company_name ||
                                                letterTemp.header_email
                                            ) && (
                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Header Full Image (will override other footer
                                                            elements)
                                                        </label>
                                                        <div
                                                            className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo
                                                                ? "error"
                                                                : inputState.company_logo
                                                                    ? "success"
                                                                    : ""
                                                                }`}
                                                        >
                                                            <label
                                                                style={{
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    width: "29vw",
                                                                }}
                                                                htmlFor="header_full_image"
                                                            >
                                                                <CloudUpload />

                                                                <span
                                                                    className="truncate-url"
                                                                    style={{ marginLeft: "20px" }}
                                                                >
                                                                    {letterTemp.header_full_image
                                                                        ? letterTemp.header_full_image instanceof File
                                                                            ? letterTemp.header_full_image.name
                                                                            : letterTemp.header_full_image
                                                                        : "No file selected"}
                                                                </span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                id="header_full_image"
                                                                name="header_full_image"
                                                                accept=".png , image/*"
                                                                onChange={handleChange}
                                                                style={{ display: "none", position: "relative" }}
                                                                disabled={isHeaderFieldsDisabled}
                                                            />
                                                            {letterTemp?.header_full_image && (
                                                                <span
                                                                    className="file-clear"
                                                                    onClick={(e) =>
                                                                        handleFileClear(e, "header_full_image")
                                                                    }
                                                                >
                                                                    Clear
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                            {!letterTemp.header_full_image && (
                                                <>
                                                    <div className="flex-column">
                                                        <label className="form-label">Header Logo</label>
                                                        <div
                                                            className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo
                                                                ? "error"
                                                                : inputState.company_logo
                                                                    ? "success"
                                                                    : ""
                                                                }`}
                                                        >
                                                            <label
                                                                style={{
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    width: "29vw",
                                                                }}
                                                                htmlFor="header_logo"
                                                            >
                                                                <CloudUpload />
                                                                <span
                                                                    className=" truncate-url"
                                                                    style={{ marginLeft: "20px" }}
                                                                >
                                                                    {letterTemp.header_logo
                                                                        ? letterTemp.header_logo instanceof File
                                                                            ? letterTemp.header_logo.name
                                                                            : letterTemp.header_logo
                                                                        : "No file selected"}
                                                                </span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                id="header_logo"
                                                                name="header_logo"
                                                                accept=".png , image/*"
                                                                onChange={handleChange}
                                                                style={{
                                                                    display: "none",
                                                                    position: "relative",
                                                                }}
                                                            />
                                                            {letterTemp.header_logo && (
                                                                <span
                                                                    className="file-clear"
                                                                    onClick={(e) =>
                                                                        handleFileClear(e, "header_logo")
                                                                    }
                                                                >
                                                                    Clear
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="flex-column">
                                                        <div className="flex-column">
                                                            <label className="form-label">Company Name</label>
                                                            <input
                                                                type="text"
                                                                name="header_company_name"
                                                                value={letterTemp.header_company_name}
                                                                onChange={handleChange}
                                                                className="file-in-upload"
                                                            />
                                                        </div>



                                                        <div className="flex-column">
                                                            <label className="form-label">Email</label>
                                                            <input
                                                                type="email"
                                                                name="header_email"
                                                                value={letterTemp.header_email}
                                                                onChange={handleChange}
                                                                className="file-in-upload"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="flex-column">
                                                        <label className="form-label">Address</label>
                                                        <TipTapEditor
                                                            value={letterTemp.header_Address}
                                                            onChange={(value) => handleQuillChange(value, "header_Address")}
                                                            style={{ width: '34vw', minHeight: '170px' }}
                                                            className="form-input-quill"
                                                        />
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">Primary Color</label>
                                                        <input
                                                            type="color"
                                                            name="header_primary_colour"
                                                            value={letterTemp.header_primary_colour}
                                                            onChange={handleChange}
                                                            className="form-control form-control-color"
                                                        />
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Secondary Color
                                                        </label>
                                                        <input
                                                            type="color"
                                                            name="header_secondery_colour"
                                                            value={letterTemp.header_secondery_colour}
                                                            onChange={handleChange}
                                                            className="form-control form-control-color"
                                                        />
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Logo Height (%)
                                                        </label>
                                                        <input
                                                            type="range"
                                                            name="header_logo_size"
                                                            min="10"
                                                            max="100"
                                                            value={letterTemp.header_logo_size || 100}
                                                            onChange={handleChange}
                                                            className="form-range"
                                                        />
                                                        <span>{letterTemp.header_logo_size || 100}%</span>
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">Logo Position</label>
                                                        <select
                                                            name="header_logo_position"
                                                            value={letterTemp.header_logo_position}
                                                            onChange={handleChange}
                                                            className="form-input-date"
                                                            style={{ width: '14vw' }}
                                                        >
                                                            <option value="left">Left</option>
                                                            <option value="right">Right</option>
                                                            <option value="center">Center</option>
                                                        </select>
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Content Position
                                                        </label>
                                                        <select
                                                            name="header_content_position"
                                                            value={letterTemp.header_content_position}
                                                            onChange={handleChange}
                                                            className="form-input-date"
                                                            style={{ width: '14vw' }}
                                                        >
                                                            <option value="left">Left</option>
                                                            <option value="right">Right</option>
                                                            <option value="center">Center</option>
                                                        </select>
                                                    </div>
                                                </>
                                            )}

                                            <div className="flex-column">
                                                <label className="form-label">Padding Left</label>
                                                <input
                                                    type="number"
                                                    name="header_left_gap"
                                                    value={letterTemp?.header_left_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Top</label>
                                                <input
                                                    type="number"
                                                    name="header_top_gap"
                                                    value={letterTemp?.header_top_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Right</label>
                                                <input
                                                    type="number"
                                                    name="header_right_gap"
                                                    value={letterTemp?.header_right_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Bottom</label>
                                                <input
                                                    type="number"
                                                    name="header_bottom_gap"
                                                    value={letterTemp?.header_bottom_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Background Image Section */}
                                {letterTemp.bg_display && (
                                    <>
                                        <div className="jd-heading-outer heading-bg-color-white">
                                            <div className="jd-heading-outer-flex">
                                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                                    Background Image
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="jd-heading-bottom-bold"></div>
                                                <div className="jd-heading-bottom-light"></div>
                                            </div>
                                        </div>
                                        <div className="form-flex-wrap">
                                            <div className="flex-column">
                                                <label className="form-label">Background Image</label>
                                                <div
                                                    className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo
                                                        ? "error"
                                                        : inputState.company_logo
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                >
                                                    <label
                                                        style={{
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            width: "29vw",
                                                        }}
                                                        htmlFor="bg_image"
                                                    >
                                                        <CloudUpload />
                                                        <span
                                                            className=" truncate-url"
                                                            style={{ marginLeft: "20px" }}
                                                        >
                                                            {letterTemp.bg_image
                                                                ? letterTemp.bg_image instanceof File
                                                                    ? letterTemp.bg_image.name
                                                                    : letterTemp.bg_image
                                                                : "No file selected"}
                                                        </span>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        id="bg_image"
                                                        name="bg_image"
                                                        accept=".png , image/*"
                                                        onChange={handleChange}
                                                        style={{ display: "none", position: "relative" }}
                                                    />
                                                    {letterTemp.bg_image && (
                                                        <span
                                                            className="file-clear"
                                                            onClick={(e) => handleFileClear(e, "bg_image")}
                                                        >
                                                            Clear
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Image Rotation</label>
                                                <input
                                                    type="number"
                                                    name="bg_angle"
                                                    min={-180}
                                                    max={180}
                                                    placeholder="-180 to 180"
                                                    onChange={handleChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input"
                                                />
                                            </div>

                                            <div className="flex-column">
                                                <label className="form-label">Padding Left</label>
                                                <input
                                                    type="number"
                                                    name="content_left_gap"
                                                    value={letterTemp.content_left_gap}
                                                    onChange={handleChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>

                                            <div className="flex-column">
                                                <label className="form-label">Padding Right</label>
                                                <input
                                                    type="number"
                                                    name="content_right_gap"
                                                    value={letterTemp.content_right_gap}
                                                    onChange={handleChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>

                                            <div className="flex-column">
                                                <label className="form-label">Size (%)</label>
                                                <input
                                                    type="range"
                                                    name="bg_size"
                                                    min="10"
                                                    max="100"
                                                    value={letterTemp.bg_size || 100}
                                                    onChange={handleChange}
                                                    className="form-range"
                                                    style={{ width: '14vw' }}
                                                />
                                                <span>{letterTemp.bg_size || 100}%</span>
                                            </div>

                                            <div className="flex-column">
                                                <label className="form-label">Opacity (%)</label>
                                                <input
                                                    type="range"
                                                    name="bg_opacity"
                                                    min="1"
                                                    max="100"
                                                    value={letterTemp.bg_opacity || 20}
                                                    onChange={handleChange}
                                                    className="form-range"
                                                    style={{ width: '14vw' }}
                                                />
                                                <span>{letterTemp.bg_opacity || 20}%</span>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* Signature Section */}

                                {letterTemp.signatory_display && (
                                    <div className="">
                                        <div className="jd-heading-outer heading-bg-color-white">
                                            <div className="jd-heading-outer-flex">
                                                <h2 className="jd-heading-main font-weight600 font-size-heading">
                                                    Signature Configuration
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="jd-heading-bottom-bold"></div>
                                                <div className="jd-heading-bottom-light"></div>
                                            </div>
                                        </div>

                                        <div className="form-flex-wrap">
                                            {/* Sign Heading */}
                                            <div className="flex-column">
                                                <label className="form-label">Signature Heading<span className="required">*</span></label>
                                                <input
                                                    type="text"
                                                    name="signatory_sign_heading"
                                                    value={letterTemp.signatory_sign_heading || ""}
                                                    onChange={handleChange}
                                                    className="file-in-upload"
                                                    placeholder="Heading"
                                                    style={{ marginBottom: '10px' }}
                                                />
                                                {isSubmitted && errors.signatory_sign_heading && (
                                                    <span className="error-message font-size-text ">{errors.signatory_sign_heading}</span>
                                                )}
                                            </div>

                                            {/* Name */}
                                            <div className="flex-column">
                                                <label className="form-label">Signatory Name</label>
                                                <input
                                                    type="text"
                                                    name="signatory_name"
                                                    value={letterTemp.signatory_name || ""}
                                                    onChange={handleChange}
                                                    className="file-in-upload"
                                                    placeholder="Name"
                                                />
                                            </div>

                                            {/* Designation */}
                                            <div className="flex-column">
                                                <label className="form-label">Designation</label>
                                                <input
                                                    type="text"
                                                    name="signatory_designation"
                                                    value={letterTemp.signatory_designation || ""}
                                                    onChange={handleChange}
                                                    className="file-in-upload"
                                                    placeholder="Designation"
                                                />
                                            </div>

                                            {/* Signature Upload */}
                                            <div className="flex-column">
                                                <label className="form-label">Signature Image<span className="required">*</span></label>
                                                <div className="file-upload-container flex-row justify-between file-in-upload" >
                                                    <label
                                                        htmlFor="signatory_signature"
                                                        style={{
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            width: "29vw",
                                                        }}
                                                    >
                                                        <CloudUpload />
                                                        <span className="truncate-url" style={{ marginLeft: "20px" }}>
                                                            {letterTemp.signatory_signature
                                                                ? letterTemp.signatory_signature instanceof File
                                                                    ? letterTemp.signatory_signature.name
                                                                    : letterTemp.signatory_signature
                                                                : "No file selected"}

                                                        </span>
                                                    </label>

                                                    <input
                                                        type="file"
                                                        id="signatory_signature"
                                                        name="signatory_signature"
                                                        accept=".png , image/*"
                                                        onChange={handleChange}
                                                        style={{ display: "none", position: "relative" }}
                                                    />

                                                    {letterTemp.signatory_signature && (
                                                        <span
                                                            className="file-clear"
                                                            onClick={(e) =>
                                                                handleFileClear(e, "signatory_signature")
                                                            }
                                                        >
                                                            Clear
                                                        </span>
                                                    )}
                                                </div>
                                                {isSubmitted && errors.signatory_signature && (
                                                    <span className="error-message font-size-text ">{errors.signatory_signature}</span>
                                                )}
                                            </div>


                                            <div className="form-flex-wrap" style={{ gap: '37px' }}>
                                                {/* Content Position */}
                                                <div className="flex-column">
                                                    <label className="form-label">Content Alignment</label>
                                                    <select
                                                        name="signatory_content_position"
                                                        value={letterTemp.signatory_content_position || "left"}
                                                        onChange={handleChange}
                                                        className="form-input"
                                                        style={{ width: '15vw' }}
                                                    >
                                                        <option value="left">Left</option>
                                                        <option value="center">Center</option>
                                                        <option value="right">Right</option>
                                                    </select>
                                                </div>

                                                {/* Signature Position */}
                                                <div className="flex-column">
                                                    <label className="form-label">Signature Image Position</label>
                                                    <select
                                                        name="signatory_sign_position"
                                                        value={letterTemp.signatory_sign_position || "left"}
                                                        onChange={handleChange}
                                                        className="form-input"
                                                        style={{ width: '15vw' }}
                                                    >
                                                        <option value="left">Left</option>
                                                        <option value="center">Center</option>
                                                        <option value="right">Right</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-flex-wrap" style={{ gap: '37px' }}>
                                                {/* Overall Position */}
                                                <div className="flex-column">
                                                    <label className="form-label">Overall Position(in row)</label>
                                                    <select
                                                        name="signatory_overall_position"
                                                        value={letterTemp.signatory_overall_position || "left"}
                                                        onChange={handleChange}
                                                        className="form-input"
                                                        style={{ width: '15vw' }}
                                                    >
                                                        <option value="left">Left</option>
                                                        <option value="center">Center</option>
                                                        <option value="right">Right</option>
                                                    </select>
                                                </div>



                                                <div className="flex-column">
                                                    <label className="form-label">Overall Placement</label>
                                                    <select
                                                        name="signatory_overall_placement"
                                                        value={letterTemp.signatory_overall_placement || "End"}
                                                        onChange={handleChange}
                                                        className="form-input"
                                                        style={{ width: '15vw' }}
                                                    >
                                                        <option value="Start">Before Content</option>
                                                        <option value="End">After Content</option>
                                                    </select>
                                                </div>

                                            </div>

                                            {/* Signature Size */}
                                            <div className="form-flex-wrap">
                                                <div className="flex-column">
                                                    <label className="form-label">Signature Size (%)</label>
                                                    <input
                                                        type="range"
                                                        name="signatory_sign_size"
                                                        min="30"
                                                        max="200"
                                                        value={letterTemp.signatory_sign_size || 100}
                                                        onChange={handleChange}
                                                        className="form-range"
                                                        style={{ width: '35.5vw' }}
                                                    />
                                                    <span>{letterTemp.signatory_sign_size || 100}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Footer Section */}
                                {letterTemp.footer_display && (
                                    <div className="">
                                        <div className="jd-heading-outer heading-bg-color-white">
                                            <div className="jd-heading-outer-flex">
                                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                                    Footer Configuration
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="jd-heading-bottom-bold"></div>
                                                <div className="jd-heading-bottom-light"></div>
                                            </div>
                                        </div>
                                        <div className="form-flex-wrap">
                                            {!(
                                                letterTemp.footer_logo ||
                                                letterTemp.footer_company_name ||
                                                letterTemp.footer_email
                                            ) && (
                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Footer Full Image (will override other footer
                                                            elements)
                                                        </label>
                                                        <div
                                                            className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo
                                                                ? "error"
                                                                : inputState.company_logo
                                                                    ? "success"
                                                                    : ""
                                                                }`}
                                                        >
                                                            <label
                                                                style={{
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    width: "29vw",
                                                                }}
                                                                htmlFor="footer_full_image"
                                                            >
                                                                <CloudUpload />
                                                                <span
                                                                    className="truncate-url"
                                                                    style={{ marginLeft: "20px" }}
                                                                >
                                                                    {letterTemp.footer_full_image
                                                                        ? letterTemp.footer_full_image instanceof File
                                                                            ? letterTemp.footer_full_image.name
                                                                            : letterTemp.footer_full_image
                                                                        : "No file selected"}
                                                                </span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                id="footer_full_image"
                                                                name="footer_full_image"
                                                                accept=".png , image/*"
                                                                onChange={handleChange}
                                                                style={{ display: "none", position: "relative" }}
                                                                disabled={isFooterFieldsDisabled}
                                                            />
                                                            {letterTemp.footer_full_image && (
                                                                <span
                                                                    className="file-clear"
                                                                    onClick={(e) =>
                                                                        handleFileClear(e, "footer_full_image")
                                                                    }
                                                                >
                                                                    Clear
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            {!letterTemp.footer_full_image && (
                                                <>
                                                    <div className="flex-column">
                                                        <label className="form-label">Footer Logo</label>
                                                        <div
                                                            className={`file-upload-container flex-row justify-between file-in-upload ${errors.company_logo
                                                                ? "error"
                                                                : inputState.company_logo
                                                                    ? "success"
                                                                    : ""
                                                                }`}
                                                        >
                                                            <label
                                                                style={{
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    width: "29vw",
                                                                }}
                                                                htmlFor="footer_logo"
                                                            >
                                                                <CloudUpload />
                                                                <span
                                                                    className=" truncate-url"
                                                                    style={{ marginLeft: "20px" }}
                                                                >
                                                                    {letterTemp.footer_logo
                                                                        ? letterTemp.footer_logo instanceof File
                                                                            ? letterTemp.footer_logo.name
                                                                            : letterTemp.footer_logo
                                                                        : "No file selected"}
                                                                </span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                id="footer_logo"
                                                                name="footer_logo"
                                                                accept=".png , image/*"
                                                                onChange={handleChange}
                                                                style={{
                                                                    display: "none",
                                                                    position: "relative",
                                                                }}
                                                            />
                                                            {letterTemp.footer_logo && (
                                                                <span
                                                                    className="file-clear"
                                                                    onClick={(e) =>
                                                                        handleFileClear(e, "footer_logo")
                                                                    }
                                                                >
                                                                    Clear
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="flex-column" >
                                                        <div className="flex-column">
                                                            <label className="form-label">Company Name</label>
                                                            <input
                                                                type="text"
                                                                name="footer_company_name"
                                                                value={letterTemp.footer_company_name}
                                                                onChange={handleChange}
                                                                className="file-in-upload"
                                                            />
                                                        </div>
                                                        <div className="flex-column">
                                                            <label className="form-label">Email</label>
                                                            <input
                                                                type="email"
                                                                name="footer_email"
                                                                value={letterTemp.footer_email}
                                                                onChange={handleChange}
                                                                className="file-in-upload"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">Address</label>
                                                        <TipTapEditor
                                                            value={letterTemp.footer_Address}
                                                            onChange={(value) =>
                                                                handleQuillChange(value, "footer_Address")
                                                            }
                                                            className="form-input-quill"
                                                            style={{ width: '34vw', minHeight: '170px' }}
                                                        />
                                                    </div>



                                                    <div className="flex-column">
                                                        <label className="form-label">Primary Color</label>
                                                        <input
                                                            type="color"
                                                            name="footer_primary_colour"
                                                            value={letterTemp.footer_primary_colour}
                                                            onChange={handleChange}
                                                            className="form-control form-control-color"
                                                        />
                                                    </div>
                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Secondary Color
                                                        </label>
                                                        <input
                                                            type="color"
                                                            name="footer_secondery_colour"
                                                            value={letterTemp.footer_secondery_colour}
                                                            onChange={handleChange}
                                                            className="form-control form-control-color"
                                                        />
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Logo Height (%)
                                                        </label>
                                                        <input
                                                            type="range"
                                                            name="footer_logo_size"
                                                            min="10"
                                                            max="100"
                                                            value={letterTemp.footer_logo_size || 100}
                                                            onChange={handleChange}
                                                            className="form-range"
                                                        />
                                                        <span>{letterTemp.footer_logo_size || 100}%</span>
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">Logo Position</label>
                                                        <select
                                                            name="footer_logo_position"
                                                            value={letterTemp.footer_logo_position}
                                                            onChange={handleChange}
                                                            className="form-input-date"
                                                            style={{ width: '14vw' }}
                                                        >
                                                            <option value="left">Left</option>
                                                            <option value="right">Right</option>
                                                            <option value="center">Center</option>
                                                        </select>
                                                    </div>

                                                    <div className="flex-column">
                                                        <label className="form-label">
                                                            Content Position
                                                        </label>
                                                        <select
                                                            name="footer_content_position"
                                                            value={letterTemp.footer_content_position}
                                                            onChange={handleChange}
                                                            className="form-input-date"
                                                            style={{ width: '14vw' }}
                                                        >
                                                            <option value="left">Left</option>
                                                            <option value="right">Right</option>
                                                            <option value="center">Center</option>
                                                        </select>
                                                    </div>
                                                </>
                                            )}
                                            <div className="flex-column">
                                                <label className="form-label">Padding Left</label>
                                                <input
                                                    type="number"
                                                    name="footer_left_gap"
                                                    value={letterTemp.footer_left_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Right</label>
                                                <input
                                                    type="number"
                                                    name="footer_right_gap"
                                                    value={letterTemp.footer_right_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Top</label>
                                                <input
                                                    type="number"
                                                    name="footer_top_gap"
                                                    value={letterTemp.footer_top_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-label">Padding Bottom</label>
                                                <input
                                                    type="number"
                                                    name="footer_bottom_gap"
                                                    value={letterTemp.footer_bottom_gap}
                                                    onChange={handlePaddingChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-input-date"
                                                    style={{ width: '14vw' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </form>

                            {(letterTemp?.letter_format_count || letterTemp?.employee_letter_count) > 0 && (
                                <div className="flex-column" style={{ marginTop: "5px" }}>
                                    <label
                                        className="form-labels font-weight500 font-size-subheading flex item-center gap-1"
                                        style={{ marginTop: "5px" }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={variableConfirmation}
                                            onChange={(e) =>
                                                setVariableConfirmation(e.target.checked)
                                            }
                                        />
                                        <span style={{ color: 'red' }}>
                                            {`Note: This template is ${letterTemp?.letter_format_count > 0
                                                ? `used in ${letterTemp.letter_format_count} format${letterTemp.letter_format_count > 1 ? 's' : ''}`
                                                : ''
                                                }${letterTemp?.letter_format_count > 0 && letterTemp?.employee_letter_count > 0
                                                    ? ' and '
                                                    : ''
                                                }${letterTemp?.employee_letter_count > 0
                                                    ? `sent in ${letterTemp.employee_letter_count} employee${letterTemp.employee_letter_count > 1 ? 's' : ''} letter${letterTemp.employee_letter_count > 1 ? 's' : ''}`
                                                    : ''
                                                }. Please confirm you still want to edit the letter template.`}
                                        </span>
                                    </label>
                                </div>
                            )}

                            <div className="button-models">
                                <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}
                                >
                                    Cancel
                                </button>

                                <ViewLetterBuilder templateData={letterTemp} />
                                <button
                                    type="submit"
                                    className={`${(letterTemp?.letter_format_count ||
                                        letterTemp?.employee_letter_count) > 0 &&
                                        !variableConfirmation
                                        ? "model-button model-button-cancel font-weight500"
                                        : "model-button model-button-leave font-weight500 font-size-heading"
                                        }`}
                                    disabled={
                                        loading ||
                                        (letterTemp?.letter_format_count > 0 &&
                                            letterTemp?.employee_letter_count > 0 &&
                                            !variableConfirmation)
                                    }
                                    onClick={handleSubmit}
                                >
                                    {(letterTemp?.letter_format_count ||
                                        letterTemp?.employee_letter_count) > 0
                                        ? variableConfirmation
                                            ? "Update Letter"
                                            : "Confirmation Needed"
                                        : "Update Letter"}
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                </Modal.Body>
            </Modal>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

const LetterDelete = ({ i, getLetterTemplateData }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/letter-builder-template-update-delete/${i.id}/`
            );
            if (res.status === 200) {
                await getLetterTemplateData();
                setShow(false);
                toast.success("Template Deleted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Letter Template </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete letter template of{" "}
                        <b>{i?.template_name}</b>
                        <div className="button-models">
                            <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};


const ViewLetterBuilder = ({
    buttonDisplay,
    buttonDisplayName,

    templateID,
    templateData,

    formatID,
    formatData,

    empLetterID,
    empLetterData,

    onClose,
    renderedContent,
}) => {



    const [show, setShow] = useState(false);
    const handleClose = () => {
        setLetterTemplateData({})
        setLetterFormatData({})
        setEmployeeLetterData({})
        setShow(false);
        if (onClose) onClose();
    };

    const handleShow = () => {
        if (templateID && !templateData) {
            getLetterTemplateData()
        } else if (templateData) {
            setLetterTemplateData(templateData)
        }

        if (formatID && !formatData) {
            getLetterFormatData();
        } else if (formatData) {
            setLetterFormatData(formatData)
        }

        if (empLetterID && !empLetterData) {
            getEmployeeLetterTemplateData()
        } else if (empLetterData) {
            setEmployeeLetterData(empLetterData)
        }

        setShow(true);
    };

    const [letterTemplateData, setLetterTemplateData] = useState(templateData || {});
    const [buffer1, setBuffering1] = useState(false);
    const getLetterTemplateData = async () => {
        setBuffering1(true);
        try {
            const template = await axios.get(`${BASE_URL}/wfm/letter-builder-template-byid/${templateID}/`);
            setLetterTemplateData(template.data);
        } catch (err) {
            if (!templateID) {
                toast.warning("Select/Give Letter Template ID ");
            } else {
                handleErrorToast(err);
            }
        } finally {
            setBuffering1(false);
        }
    };

    const [letterFormatData, setLetterFormatData] = useState(formatData || {});
    const [buffer2, setBuffering2] = useState(false);
    const getLetterFormatData = async () => {
        setBuffering2(true);
        try {
            const format = await axios.get(`${BASE_URL}/wfm/letter-builder-formatwithvariables-byid/${formatID}/`);
            setLetterFormatData(format.data);
        } catch (err) {
            if (!formatID) {
                toast.warning("Select/Give Letter Format ID ")
            } else {
                handleErrorToast(err)
            }
        } finally {
            setBuffering2(false);
        }
    };

    const [employeeLetterData, setEmployeeLetterData] = useState(empLetterData || {});
    const [buffer3, setBuffering3] = useState(false);
    const getEmployeeLetterTemplateData = async () => {
        setBuffering3(true);
        try {
            const empLetter = await axios.get(`${BASE_URL}/wfm/letter-builder-employeeletterwithvariables-byid/${empLetterID}/`);
            setEmployeeLetterData(empLetter.data);
        } catch (err) {
            if (!empLetterID) {
                toast.warning("Select/Give Employee Letter ID ")
            } else {
                handleErrorToast(err)
            }
        } finally {
            setBuffering3(false);
        }
    };

    // const fontSize = letterFormatData?.font_size || "13";
    const lineHeight = letterFormatData?.line_height || 1.5;
    const toGetVariablesValue =
        empLetterID !== undefined
            ? employeeLetterData[0]?.employee_letter_variables
            : employeeLetterData?.employee_letter_variables;
    const checkVariables =
        toGetVariablesValue === undefined
            ? letterFormatData?.letter_format_variables
            : toGetVariablesValue;


    const paginatedContent = letterFormatData?.description;

    // function decodeHtmlEntities(str) {
    //     const textarea = document.createElement("textarea");
    //     textarea.innerHTML = str;
    //     return textarea.value;
    // }
    function decodeHtmlEntities(str) {
        if (!str) return str;

        const safe = str.replace(/style="([^"]*)"/g, (match, css) =>
            `style="${css.replace(/&quot;/g, "'")}"`
        );

        const textarea = document.createElement("textarea");
        textarea.innerHTML = safe;
        return textarea.value;
    }

    function replaceVariables(content, empLetterVariables) {
        if (!empLetterVariables || !Array.isArray(empLetterVariables))
            return content;

        const variableMap = empLetterVariables.reduce((map, item) => {
            map[item.var_key] =
                item.var_value === "" ? item.var_name : item.var_value;
            return map;
        }, {});

        const decodedContent = decodeHtmlEntities(content);

        return decodedContent?.replace(/{{(\d+)}}/g, (match, varKey) => {
            const varName = variableMap[varKey];
            if (varName) {
                return ` ${empLetterVariables[0]?.var_value ? varName : `{{${varName}}}`
                    }`;
            }
            return match;
        });
    }


    const defaultButton = (
        <button
            type="button"
            title="Preview"
            className="model-button model-button-cancel"
            onClick={handleShow}
        >
            <Eye /> {buttonDisplayName || "Preview"}
        </button>
    );

    const buttonVariants = {
        'Eye': (
            <button
                type="button"
                title={buttonDisplayName || "View"}
                onClick={handleShow}
            >
                <Eye />
            </button>
        ),
        'Name': (
            <button
                type="button"
                title={buttonDisplayName || "View"}
                style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
                onClick={handleShow}
            >
                {buttonDisplayName || "View"}
            </button>
        ),
        'Eye-Name': (
            <button
                type="button"
                title={buttonDisplayName || "View"}
                style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
                onClick={handleShow}
            >
                <Eye /> {buttonDisplayName || "View"}
            </button>
        ),

        'Model-Eye': (
            <button
                type="button"
                title={buttonDisplayName || "View"}
                className="model-button model-button-cancel"
                onClick={handleShow}
            >
                <Eye />
            </button>
        ),
        'Model-Name': (
            <button
                type="button"
                className="model-button model-button-cancel"
                onClick={handleShow}
            >
                {buttonDisplayName || "View"}
            </button>
        ),
        'Model-Eye-Name': (
            <button
                type="button"
                className="model-button model-button-cancel"
                onClick={handleShow}
            >
                <Eye /> {buttonDisplayName || "View"}
            </button>
        ),
    };

    const finalDescription = replaceVariables(paginatedContent, checkVariables);




    // const htmlString = ReactDOMServer.renderToString(splitcontent);
    const ref = useRef();

    const printButton = (
        <ReactToPrint
            bodyClass="print-agreement"
            content={() => ref.current}
            onBeforeGetContent={() => {
                return new Promise((resolve) => {
                    // Get the dynamic page size, defaulting to A4 if not found
                    const requiredPageSize = letterTemplateData?.page_size || "A4";

                    // Trigger the native browser alert
                    window.alert(
                        `IMPORTANT PRINT SETTINGS:\n\n1. Set Paper Size to: ${requiredPageSize}\n2. Set Margins to: None\n3. Uncheck "Headers and footers"\n\nFailure to do so may result in cropped content.`
                    );

                    resolve(); // Let ReactToPrint continue opening the print dialog
                });
            }}
            trigger={() => (
                <button
                    className="model-button model-button-black"
                    style={{ marginLeft: "10px" }}
                >
                    <Printer /> Print
                </button>
            )}
        />
    );

    return (
        <>
            {buttonVariants[buttonDisplay] || defaultButton}
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* <LetterPreview
        letterTemplateData={letterTemplateData}
        show={show}
        handleClose={handleClose}
        letterFormatName={letterFormatData?.letter_name}
        buffer1={buffer1}
        buffer2={buffer2}
        buffer3={buffer3}
        fontSize={fontSize}
      >
        {finalDescription}
      </LetterPreview> */}


            {/* <TemplateDisplayWrapper
        isModal={true}
        show={show}
        handleClose={handleClose}
        letterTemplateData={letterTemplateData}
        letterFormatName={letterFormatData?.letter_name}
        buffer1={buffer1}
        buffer2={buffer2}
        buffer3={buffer3}
        fontSize={fontSize}
      >
        {finalDescription}
      </TemplateDisplayWrapper> */}

            <Modal show={show} onHide={handleClose}
                size="xl"
                centered
                dialogClassName="flex justify-center lettertemp-modal"
            >
                <Modal.Header closeButton className="sticky-modal-header">
                    <Modal.Title>
                        Letter Template -{" "}
                        <span className="dynamic-modal-title">
                            {letterFormatData?.letter_name ||
                                letterTemplateData?.template_name}
                        </span>
                    </Modal.Title>
                    {printButton}
                </Modal.Header>
                <Modal.Body>
                    <LetterPreview
                        ref={ref}
                        letterTemplateData={letterTemplateData}
                        // fontSize={fontSize}
                        lineHeight={lineHeight}
                        buffer1={buffer1}
                        buffer2={buffer2}
                        buffer3={buffer3}
                        contentBorderDisplay={templateData && !templateID}
                        showDefaultSignText={false}
                    >
                        {finalDescription}
                    </LetterPreview>
                </Modal.Body>
                <Modal.Footer className="modal-btn-pos">
                    <button
                        className="justify-center model-button model-button-cancel font-weight500"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal >

        </>
    );
};


const informativeTypeOptions = [
    { value: "policy_update", label: "Policy Update" },
    { value: "announcement", label: "Announcement" },
    { value: "general_reminder", label: "General Reminder" },
    { value: "circular", label: "Circular" },
    { value: "notice", label: "Notice" },
];

const AddLetterFormat = ({
    getLetterFormatsData,
    SUB_COMPANIES,
    SUPER_ADMIN,
}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleShow = () => {
        getLetterTemplates();
        setShow(true);
    };

    const [editorContent, setEditorContent] = useState("");
    const [variables, setVariables] = useState([]);
    const [addedValues, setAddedValues] = useState([]);
    const quillRef = useRef(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [buffer1, setBuffering1] = useState(true);
    const [isEditorFocused, setIsEditorFocused] = useState(false);

    //  UPDATED: new letter_type options + added letter_type_detail field
    const initialFormatData = {
        sub_company: sessionStorage.getItem("company_id"),
        letter_template: "",
        letter_name: "",
        subject: "",
        description: "",
        letter_format_variables: [],
        line_height: 1.5,
        // letter_rating: "",
        letter_type_detail: "",       // ✅ NEW field for informative dropdown / others free text
        informative_details: "",
        other_details: "",
        letter_type: "",
        issued_by: "",
    };

    const [formData, setFormData] = useState(initialFormatData);

    const handleClose = () => {
        setShow(false);

        // Reset all states
        setFormData(initialFormatData);
        setErrors({});
        setInputState({});

        setVariables([]);
        setEditorContent("");
        setIsEditorFocused(false);

        // Reset Quill editor manually
        if (quillRef.current) {
            quillRef.current.clear();
        }
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "letter_template",
            "sub_company",
            "letter_name",
            "subject",
            "description",
            "line_height",
            "letter_type",
        ];

        // requiredFields.forEach((field) => {
        //   if (
        //     formData[field] === null ||
        //     formData[field] === undefined ||
        //     formData[field] === ""
        //   ) {
        //     newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
        //       } is required!`;
        //   }
        // });

        requiredFields.forEach((field) => {
            if (field === "description") {
                const plainText = formData.description
                    ?.replace(/<(.|\n)*?>/g, "")
                    .replace(/&nbsp;/g, "")
                    .trim();

                if (!plainText) {
                    newErrors.description = "Description is required!";
                }
            } else {
                if (
                    formData[field] === null ||
                    formData[field] === undefined ||
                    formData[field] === ""
                ) {
                    newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                        } is required!`;
                }
            }
        });

        //  UPDATED: Rating only required for warning & appreciation (1–5)
        // if (["warning", "appreciation"].includes(formData.letter_type)) {
        //   if (
        //     formData.letter_rating === "" ||
        //     formData.letter_rating === null ||
        //     formData.letter_rating === undefined
        //   ) {
        //     newErrors.letter_rating = "Letter rating is required!";
        //   } else {
        //     const rating = parseFloat(formData.letter_rating);
        //     if (isNaN(rating) || rating < 1 || rating > 5) {
        //       newErrors.letter_rating = "Rating must be between 1 and 5 (decimals allowed, e.g. 3.5)!";
        //     }
        //   }
        // }

        if (["warning", "appreciation"].includes(formData.letter_type)) {
            if (!formData.issued_by?.trim()) {
                newErrors.issued_by = "Please select Issued By!";
            }
        }

        if (formData.letter_type === "informative") {
            if (!formData.informative_details?.trim()) {
                newErrors.informative_details =
                    "Please select an informative type!";
            }
        }

        if (formData.letter_type === "others") {
            if (!formData.other_details?.trim()) {
                newErrors.other_details =
                    "Please specify the letter type!";
            }
        }

        // Variable key/value validation (unchanged)
        if (variables.length > 0) {
            variables.forEach((pair, index) => {
                if (!pair?.var_key?.trim()) {
                    newErrors[`letter_format_variables[${index}].var_key`] =
                        "Variable key is required!";
                }
                if (!pair?.var_name?.trim()) {
                    newErrors[`letter_format_variables[${index}].var_name`] =
                        "Variable value is required!";
                }
            });
        }

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    const applyVariablesToEditor = (baseContent, variableList) => {
        let updatedContent = baseContent;
        const validLabels = [];

        const activeKeys = variableList
            .map((v) => `{{${v.var_key?.trim()}}}`)
            .filter(Boolean);

        const activeLabels = variableList
            .map((v) => v.var_name?.trim())
            .filter(Boolean);

        const allMatches = [...new Set(updatedContent.match(/{{\d+}}/g))];
        if (allMatches) {
            allMatches.forEach((match) => {
                if (!activeKeys.includes(match)) {
                    const regex = new RegExp(
                        match.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
                        "g"
                    );
                    updatedContent = updatedContent.replace(regex, "");
                }
            });
        }

        setEditorContent(updatedContent);

        if (quillRef.current) {
            quillRef.current.setHTML(updatedContent);
        }

        setAddedValues(validLabels);
        setFormData((prevData) => ({
            ...prevData,
            description: updatedContent,
        }));
    };

    const handleVariableChange = (index, field, value) => {
        const updated = [...variables];
        updated[index][field] = value;
        setVariables(updated);

        setFormData((prevData) => ({
            ...prevData,
            letter_format_variables: updated,
        }));

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (field === "var_key") {
                delete updatedErrors[`letter_format_variables[${index}].var_key`];
            }
            if (field === "var_name") {
                delete updatedErrors[`letter_format_variables[${index}].var_name`];
            }
            return updatedErrors;
        });
    };

    const handleRemoveVariable = (index) => {
        const newVars = [...variables];
        newVars.splice(index, 1);
        setVariables(newVars);

        setFormData((prevData) => ({
            ...prevData,
            letter_format_variables: newVars,
        }));

        if (editorContent) {
            applyVariablesToEditor(editorContent, newVars);
        }
    };

    const handleAddVariableClick = () => {
        if (!isEditorFocused) {
            toast.warning("Please click inside the editor before adding variables.");
            return;
        }
        handleAddVariable();
    };

    const getNextKey = (variables) => {
        if (!variables.length) return 1;

        const usedKeys = variables
            .map((v) => Number(v.var_key))
            .filter((n) => !isNaN(n))
            .sort((a, b) => a - b);

        for (let i = 1; i <= usedKeys.length; i++) {
            if (!usedKeys.includes(i)) {
                return i;
            }
        }

        return Math.max(...usedKeys) + 1;
    };

    const handleAddVariable = () => {
        if (!quillRef.current) return;
        const nextNumber = getNextKey(variables);
        const keyStr = `${nextNumber}`;

        quillRef.current.insertVariable(keyStr);

        const newVariable = { var_key: keyStr, var_name: "", var_value: "" };
        const newVariables = [...variables, newVariable];
        setVariables(newVariables);

        const currentContent = quillRef.current.getHTML();
        setEditorContent(currentContent);

        setFormData((prevData) => ({
            ...prevData,
            letter_format_variables: newVariables,
            description: currentContent,
        }));
    };

    const [lettersTemplate, setLettersTemplateData] = useState([]);

    const getLetterTemplates = async () => {
        setBuffering1(true);
        try {
            const template = await axios.get(
                `${BASE_URL}/wfm/letter-builder-template-bysubcompany/${formData.sub_company}/`
            );
            setLettersTemplateData(template.data);
        } catch (err) {
            if (formData.sub_company != "") {
                handleErrorToast(err);
            } else {
                toast.warning("Select Subcompany First!");
            }
        } finally {
            setBuffering1(false);
        }
    };

    useEffect(() => {
        getLetterTemplates();
    }, [formData.sub_company]);

    const convertSpaces = (html) => {
        return html.replace(/  /g, "&nbsp;&nbsp;");
    };

    const onEditorContentChange = (content) => {
        const contentWithSpaces = convertSpaces(content);
        const fixedContent = contentWithSpaces.replace(
            /href="(?!http)([^"]+)"/g,
            'href="https://$1"'
        );

        setEditorContent(fixedContent);

        const matches = fixedContent.match(/{{\d+}}/g) || [];
        const keysInEditor = matches.map((m) => m.replace(/[{}]/g, ""));

        const updatedVariables = variables.filter((v) =>
            keysInEditor.includes(v.var_key)
        );

        setVariables(updatedVariables);

        setFormData((prev) => ({
            ...prev,
            description: fixedContent,
            letter_format_variables: updatedVariables,
        }));

        if (isSubmitted && content.trim() !== "") {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors.description;
                return newErrors;
            });

            setInputState((prev) => ({
                ...prev,
                description: true,
            }));
        }
    };

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const handleInputChange = (e) => {
        const { name, value, type } = e.target;

        // Clear error for this field on change
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (name === "letter_type") {
            setFormData((prev) => ({
                ...prev,
                letter_type: value,
                // letter_rating: ["informative", "others"].includes(value) ? 0 : "",
                issued_by: "",
                informative_details: "",
                other_details: "",
            }));

            setErrors((prev) => {
                const updated = { ...prev };

                // delete updated.letter_rating;
                delete updated.issued_by;
                delete updated.informative_details;
                delete updated.other_details;

                return updated;
            });

            setInputState((prev) => ({
                ...prev,
                // letter_rating: "",
                issued_by: "",
                informative_details: "",
                other_details: "",
            }));

            return;
        }
        //  UPDATED: letter_rating — now only 1 to 5, only for warning & appreciation
        // if (name === "letter_rating") {
        //   const numValue = value === "" ? "" : Number(value);

        //   if (value === "") {
        //     setFormData((prev) => ({ ...prev, [name]: "" }));
        //     return;
        //   }

        //   if (numValue < 1) {
        //     setErrors((prev) => ({
        //       ...prev,
        //       letter_rating: "Minimum rating is 1",
        //     }));
        //     return;
        //   }

        //   if (numValue > 5) {
        //     setErrors((prev) => ({
        //       ...prev,
        //       letter_rating: "Maximum rating is 5",
        //     }));
        //     return;
        //   }

        //   setFormData((prev) => ({ ...prev, [name]: numValue }));
        //   setInputState((prev) => ({
        //     ...prev,
        //     [name]: numValue !== "" ? "green" : "",
        //   }));

        //   return;
        // }


        // if (name === "letter_rating") {
        //   if (value === "") {
        //     setFormData((prev) => ({ ...prev, [name]: "" }));
        //     setErrors((prev) => ({ ...prev, letter_rating: "" }));
        //     return;
        //   }

        //   const numValue = parseFloat(parseFloat(value).toFixed(1));

        //   if (isNaN(numValue)) return;

        //   if (numValue < 1) {
        //     setErrors((prev) => ({
        //       ...prev,
        //       letter_rating: "Minimum rating is 1",
        //     }));
        //     return;
        //   }

        //   if (numValue > 5) {
        //     setErrors((prev) => ({
        //       ...prev,
        //       letter_rating: "Maximum rating is 5",
        //     }));
        //     return;
        //   }

        //   setErrors((prev) => {
        //     const updated = { ...prev };
        //     delete updated.letter_rating;
        //     return updated;
        //   });

        //   setFormData((prev) => ({ ...prev, [name]: numValue }));
        //   setInputState((prev) => ({
        //     ...prev,
        //     [name]: "green",
        //   }));

        //   return;
        // }

        // Generic handler for all other fields (unchanged)
        let updatedValue = value;

        if (type === "number" || name === "line_height") {
            updatedValue = value === "" ? "" : Number(value);
        }

        setInputState({
            ...inputState,
            [name]: updatedValue ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: updatedValue,
        });
    };

    useEffect(() => {
        try { localStorage.setItem("LetterFormatFormaData", JSON.stringify(formData)); } catch (e) { console.warn("LocalStorage quota exceeded"); }
    }, [formData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                const res = await axios.post(
                    `${BASE_URL}/wfm/letter-builder-formatwithvariables/`,
                    formData
                );

                if (res.status === 200 || res.status === 201) {
                    await getLetterFormatsData();
                    setShow(false);
                    setFormData(initialFormatData);
                    setEditorContent("");
                    setVariables([]);
                    toast.success("Template build successfully!");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };



    return (
        <>
            <button
                title="Add Letter Format"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Letter Format
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Letter Format Builder</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                <div className="form-flex-wrap">
                                    {SUPER_ADMIN && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Sub Company<span className="required">*</span>
                                            </label>
                                            <select
                                                name="sub_company"
                                                value={formData.sub_company}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.sub_company
                                                    ? "error"
                                                    : inputState.sub_company
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select a Company</option>
                                                {SUB_COMPANIES.map((i, index) => (
                                                    <option key={index} value={i.id}>
                                                        {i.title}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text">
                                                    {errors.sub_company}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Letter Templates<span className="required">*</span>
                                        </label>
                                        {buffer1 ? (
                                            <div className="form-loader">
                                                <div className="bar-loader"></div>
                                            </div>
                                        ) : (
                                            <select
                                                name="letter_template"
                                                value={formData.letter_template}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.letter_template
                                                    ? "error"
                                                    : inputState.letter_template
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select a Template</option>
                                                {lettersTemplate.map((i, index) => (
                                                    <option key={index} value={i.id}>
                                                        {i.template_name}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                        {errors.letter_template && (
                                            <span className="error-message font-size-text">
                                                {errors.letter_template}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Letter Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="letter_name"
                                            value={formData.letter_name}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.letter_name
                                                ? "error"
                                                : inputState.letter_name
                                                    ? "success"
                                                    : ""
                                                }`}
                                            placeholder="Letter Name"
                                            required
                                        />
                                        {errors.letter_name && (
                                            <span className="error-message font-size-text">
                                                {errors.letter_name}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Subject<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.subject
                                                ? "error"
                                                : inputState.subject
                                                    ? "success"
                                                    : ""
                                                }`}
                                            placeholder="Letter Subject"
                                            required
                                        />
                                        {errors.subject && (
                                            <span className="error-message font-size-text">
                                                {errors.subject}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Line Height<span className="required">*</span>
                                        </label>
                                        <select
                                            name="line_height"
                                            value={formData.line_height}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.line_height
                                                ? "error"
                                                : inputState.line_height
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        >
                                            <option value="">Select Line Height</option>
                                            {lineHeightOptions.map((item) => (
                                                <option key={item.value} value={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.line_height && (
                                            <span className="error-message font-size-text">
                                                {errors.line_height}
                                            </span>
                                        )}
                                    </div>

                                    {/*  UPDATED: Letter Type — new 4 options */}
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Letter Type<span className="required">*</span>
                                        </label>
                                        <select
                                            name="letter_type"
                                            value={formData.letter_type}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.letter_type
                                                ? "error"
                                                : inputState.letter_type
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        >
                                            <option value="">Select Letter Type</option>
                                            <option value="warning">Warning Letter</option>
                                            <option value="appreciation">Appreciation</option>
                                            <option value="informative">Informative</option>
                                            <option value="others">Others</option>
                                        </select>
                                        {errors.letter_type && (
                                            <span className="error-message font-size-text">
                                                {errors.letter_type}
                                            </span>
                                        )}
                                    </div>

                                    {/* ✅ NEW: Issued By dropdown */}
                                    {["warning", "appreciation"].includes(formData.letter_type) && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Issued By<span className="required">*</span>
                                            </label>
                                            <select
                                                name="issued_by"
                                                value={formData.issued_by}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.issued_by
                                                    ? "error"
                                                    : inputState.issued_by
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select Issued By</option>
                                                {formData.letter_type === "appreciation" && (
                                                    <>
                                                        <option value="client_appreciation">By Client</option>
                                                        <option value="team_appreciation">By Team</option>
                                                    </>
                                                )}
                                                {formData.letter_type === "warning" && (
                                                    <>
                                                        <option value="client_warning">By Client</option>
                                                        <option value="team_warning">By Team</option>
                                                        <option value="pip">PIP</option>
                                                    </>
                                                )}
                                            </select>
                                            {errors.issued_by && (
                                                <span className="error-message font-size-text">
                                                    {errors.issued_by}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    {/* ✅ UPDATED: Rating — commented out */}
                                    {/* {["warning", "appreciation"].includes(formData.letter_type) && (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Letter Rating (1-5)<span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        name="letter_rating"
                        placeholder="e.g. 3.5 (between 1 and 5)"
                        id="letter_rating"
                        min={1}
                        max={5}
                        step={0.1}
                        value={formData.letter_rating}
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        className={`form-input ${errors.letter_rating
                          ? "error"
                          : inputState.letter_rating
                            ? "success"
                            : ""
                          }`}
                        required
                      />
                      {errors.letter_rating && (
                        <span className="error-message font-size-text">
                          {errors.letter_rating}
                        </span>
                      )}
                    </div>
                  )} */}

                                    {/* ✅ NEW: Informative sub-type dropdown */}
                                    {formData.letter_type === "informative" && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Informative Type<span className="required">*</span>
                                            </label>
                                            <select
                                                name="informative_details"
                                                value={formData.informative_details}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.informative_details
                                                    ? "error"
                                                    : inputState.informative_details
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select Informative Type</option>
                                                {informativeTypeOptions.map((opt) => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.informative_details && (
                                                <span className="error-message font-size-text">
                                                    {errors.informative_details}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    {/* ✅ NEW: Others — free text input */}
                                    {formData.letter_type === "others" && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Specify Letter Type<span className="required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="other_details"
                                                value={formData.other_details}
                                                placeholder="e.g. Exit Clearance, NOC, etc."
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.other_details
                                                    ? "error"
                                                    : inputState.other_details
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            />
                                            {errors.other_details && (
                                                <span className="error-message font-size-text">
                                                    {errors.other_details}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Description & Editor — completely unchanged */}
                                <div className="form-flex-wrap">
                                    <div className="flex-row mb-2">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Description<span className="required">*</span>
                                        </label>
                                        <CustomTooltip
                                            position="right"
                                            tooltipContent={toolTipContent}
                                        >
                                            <span>
                                                <InfoIcon />
                                            </span>
                                        </CustomTooltip>
                                    </div>
                                    <div className="flex-column"></div>
                                </div>

                                <TipTapLetterEditor
                                    ref={quillRef}
                                    value={editorContent}
                                    onChange={onEditorContentChange}
                                    onFocus={() => setIsEditorFocused(true)}
                                    onBlur={() => setIsEditorFocused(false)}
                                    className={`builder-quill-editor form-input ${errors.description
                                        ? "error"
                                        : inputState.description
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.description && (
                                    <span className="error-message font-size-text">
                                        {errors.description}
                                    </span>
                                )}

                                {/* Add Variables — unchanged */}
                                <div className="form-flex-wrap">
                                    <div className="flex-row">
                                        <button
                                            type="button"
                                            title="Add Variables"
                                            className="upload-svg"
                                            onMouseDown={(e) => { e.preventDefault(); handleAddVariableClick(); }}
                                        >
                                            <AddwithWhiteCircle /> Add Variables
                                        </button>
                                    </div>
                                </div>

                                {variables.map((pair, index) => (
                                    <div key={index} className="variable-container">
                                        <div
                                            className="key-value-row"
                                            style={{ marginBottom: "0px" }}
                                        >
                                            <input
                                                type="text"
                                                className="form-input small-input"
                                                placeholder="Key (e.g. {{1}})"
                                                value={pair?.var_key || ""}
                                                onChange={(e) =>
                                                    handleVariableChange(index, "var_key", e.target.value)
                                                }
                                            />
                                            {/* <CreatableSelect
                        options={staticVariableOptions}
                        value={
                          pair?.var_name
                            ? staticVariableOptions.find(
                              (opt) => opt.value === pair.var_name
                            ) || {
                              label: pair.var_name,
                              value: pair.var_name,
                            }
                            : null
                        }
                        onChange={(option) =>
                          handleVariableChange(
                            index,
                            "var_name",
                            option ? option.value : ""
                          )
                        }
                        placeholder="Select or type value"
                        isClearable
                        styles={CSSForSelect}
                      /> */}

                                            <Select
                                                options={staticVariableOptions}
                                                value={
                                                    pair?.var_name
                                                        ? staticVariableOptions.find(
                                                            (opt) => opt.value === pair.var_name
                                                        ) || null
                                                        : null
                                                }
                                                onChange={(option) =>
                                                    handleVariableChange(
                                                        index,
                                                        "var_name",
                                                        option ? option.value : ""
                                                    )
                                                }
                                                placeholder="Select value"
                                                isClearable
                                                styles={CSSForSelect}
                                            />
                                            <button
                                                className="remove-btn"
                                                type="button"
                                                onClick={() => handleRemoveVariable(index)}
                                                title="Remove"
                                            >
                                                <CrosswithGreyCircle />
                                            </button>
                                        </div>
                                        {errors[`letter_format_variables[${index}].var_key`] && (
                                            <span className="error-message font-size-text">
                                                {errors[`letter_format_variables[${index}].var_key`]}
                                            </span>
                                        )}
                                        {errors[`letter_format_variables[${index}].var_name`] && (
                                            <span className="error-message font-size-text">
                                                {errors[`letter_format_variables[${index}].var_name`]}
                                            </span>
                                        )}
                                    </div>
                                ))}

                                {/* Buttons — unchanged */}
                                <div className="button-models">
                                    <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}
                                    >
                                        Cancel
                                    </button>

                                    <ViewLetterBuilder
                                        templateID={formData.letter_template}
                                        formatData={formData}
                                    />

                                    <button
                                        type="submit"
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                    >
                                        {loading ? "Creating..." : "Create Template Builder"}
                                    </button>
                                </div>
                            </form>
                        </div>

                        {/* Error summary — unchanged */}
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 &&
                                (Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">
                                        Please fill all mandatory fields!
                                    </h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, " ")
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(", ") + " are required!"}
                                    </h6>
                                ))}
                        </p>
                    </div>
                </Modal.Body>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Modal>
        </>
    );
};



const LetterFormatUpdate = ({
    i,
    SUPER_ADMIN,
    SUB_COMPANIES,
    getLetterFormatsData,
}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    //  UPDATED: new letter_type options + letter_type_detail added
    const [letterFormat, setLetterFormat] = useState({
        sub_company: sessionStorage.getItem("company_id"),
        letter_template: "",
        letter_name: "",
        subject: "",
        description: "",
        letter_format_variables: [],
        line_height: "",
        // letter_rating: "",
        letter_type_detail: "",
        letter_type: "",
        issued_by: "",
    });

    const [originalLetterFormat, setOriginalLetterFormat] = useState(null);
    const [variableConfirmation, setVariableConfirmation] = useState(false);
    const [isEditorFocused, setIsEditorFocused] = useState(false);
    const [lettersTemplate, setLettersTemplateData] = useState([]);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [variables, setVariables] = useState([]);
    const [addedValues, setAddedValues] = useState([]);
    const [templateContent, setTemplateContent] = useState("");
    const [buffer1, setBuffering1] = useState(true);
    const [inputValues, setInputValues] = useState({});
    const [activeVariableIndex, setActiveVariableIndex] = useState([]);

    useEffect(() => {
        setActiveVariableIndex(variables);
    }, [variables]);

    const handleClose = () => {
        setShow(false);

        //  UPDATED: reset includes letter_type_detail
        setLetterFormat({
            sub_company: sessionStorage.getItem("company_id"),
            letter_template: "",
            letter_name: "",
            subject: "",
            description: "",
            letter_format_variables: [],
            line_height: "",
            // letter_rating: "",
            letter_type_detail: "",   //  reset on close
            letter_type: "",
            issued_by: "",
        });

        setVariables([]);
        setActiveVariableIndex([]);
        setInputValues({});
        setInputState({});
        setEditorContent("");
        setTemplateContent("");
        setErrors({});
    };

    const quillRef = useRef(null);

    const getLetterTemplates = async () => {
        setBuffering1(true);
        try {
            const template = await axios.get(
                `${BASE_URL}/wfm/letter-builder-template-bysubcompany/${letterFormat.sub_company}/`
            );
            setLettersTemplateData(template.data);
        } catch (err) {
            if (letterFormat.sub_company != "") {
                handleErrorToast(err);
            } else {
                toast.warning("Select Subcompany First!");
            }
        } finally {
            setBuffering1(false);
        }
    };

    const handleShow = () => {
        const formattedData = {
            ...i,
            line_height: i?.line_height ? Number(i.line_height) : "",
            //  Ensure issued_by_detail exists when opening (old records may not have it)
            // issued_by_detail: i?.issued_by_detail || "",
            letter_type_detail:
                i?.letter_type === "informative"
                    ? (i?.informative_details || "")
                    : i?.letter_type === "others"
                        ? (i?.other_details || "")
                        : (i?.letter_type_detail || ""),
            //  Normalize letter_rating — old records may have 0 for neutral
            // letter_rating: i?.letter_rating !== undefined && i?.letter_rating !== null
            //   ? i.letter_rating
            //   : "",
            // letter_rating: i?.letter_rating !== undefined && i?.letter_rating !== null && i?.letter_rating !== ""
            //   ? (() => {
            //     const parsed = parseFloat(i.letter_rating);
            //     if (isNaN(parsed)) return "";
            //     // Show 4 for "4.00", show 4.5 for "4.50"
            //     return parsed % 1 === 0 ? parsed : parseFloat(parsed.toFixed(1));
            //   })()
            //   : "",
        };

        setLetterFormat(formattedData);

        setEditorContent(formattedData.description || "");
        setTemplateContent(formattedData.description || "");

        const vars = (formattedData.letter_format_variables || []).map((v) => ({
            ...v,
        }));

        setVariables(vars);
        setActiveVariableIndex(vars);

        const initialInputValues = {};
        vars.forEach((v, index) => {
            initialInputValues[index] = v.var_name || "";
        });

        setInputValues(initialInputValues);
        setInputState(initialInputValues);

        getLetterTemplates();
        setShow(true);
    };

    useEffect(() => { }, [letterFormat.sub_company]);

    const getNextKey = (variables) => {
        if (!variables.length) return 1;

        const usedKeys = variables
            .map((v) => Number(v.var_key))
            .filter((n) => !isNaN(n))
            .sort((a, b) => a - b);

        for (let i = 1; i <= usedKeys.length; i++) {
            if (!usedKeys.includes(i)) {
                return i;
            }
        }

        return Math.max(...usedKeys) + 1;
    };

    const handleInputChange = (e) => {
        const { name, value, type } = e.target;

        // Clear error for this field
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        //  UPDATED: letter_type — new 4 options, reset rating & detail on change
        if (name === "letter_type") {
            setLetterFormat((prev) => ({
                ...prev,
                letter_type: value,
                // letter_rating: ["informative", "others"].includes(value) ? 0 : "",
                letter_type_detail: "",   // always reset
                issued_by: "",
            }));

            setErrors((prev) => {
                const updated = { ...prev };
                // delete updated.letter_rating;
                delete updated.letter_type_detail;
                delete updated.issued_by;
                return updated;
            });

            setInputState((prev) => ({
                ...prev,
                // letter_rating: "",
                letter_type_detail: "",
                issued_by: "",
            }));

            return;
        }

        //  UPDATED: letter_rating — now only 1 to 5, only for warning & appreciation
        // if (name === "letter_rating") {
        //   const numValue = value === "" ? "" : Number(value);

        //   if (value === "") {
        //     setLetterFormat((prev) => ({ ...prev, [name]: "" }));
        //     return;
        //   }

        //   if (numValue < 1) {
        //     setErrors((prev) => ({
        //       ...prev,
        //       letter_rating: "Minimum rating is 1",
        //     }));
        //     return;
        //   }

        //   if (numValue > 5) {
        //     setErrors((prev) => ({
        //       ...prev,
        //       letter_rating: "Maximum rating is 5",
        //     }));
        //     return;
        //   }

        //   setLetterFormat((prev) => ({ ...prev, [name]: numValue }));
        //   setInputState((prev) => ({
        //     ...prev,
        //     [name]: numValue !== "" ? "green" : "",
        //   }));

        //   return;
        // }

        // if (name === "letter_rating") {
        //   if (value === "") {
        //     setLetterFormat((prev) => ({ ...prev, [name]: "" }));
        //     setErrors((prev) => ({ ...prev, letter_rating: "" }));
        //     return;
        //   }

        //   const numValue = parseFloat(parseFloat(value).toFixed(1));

        //   if (isNaN(numValue)) return;

        //   if (numValue < 1) {
        //     setErrors((prev) => ({
        //       ...prev,
        //       letter_rating: "Minimum rating is 1",
        //     }));
        //     return;
        //   }

        //   if (numValue > 5) {
        //     setErrors((prev) => ({
        //       ...prev,
        //       letter_rating: "Maximum rating is 5",
        //     }));
        //     return;
        //   }

        //   setErrors((prev) => {
        //     const updated = { ...prev };
        //     delete updated.letter_rating;
        //     return updated;
        //   });

        //   setLetterFormat((prev) => ({ ...prev, [name]: numValue }));
        //   setInputState((prev) => ({
        //     ...prev,
        //     [name]: "green",
        //   }));

        //   return;
        // }

        // Generic handler for all other fields (unchanged)
        let updatedValue = value;
        if (type === "number" || name === "line_height") {
            updatedValue = value === "" ? "" : Number(value);
        }

        setInputState({
            ...inputState,
            [name]: updatedValue ? "green" : "",
        });

        setLetterFormat({
            ...letterFormat,
            [name]: updatedValue,
        });
    };

    const [editorContent, setEditorContent] = useState(letterFormat?.description);

    const onEditorContentChange = (content) => {
        const fixedContent = content.replace(
            /href="(?!http)([^"]+)"/g,
            'href="https://$1"'
        );

        setEditorContent(fixedContent);

        setLetterFormat((prev) => ({
            ...prev,
            description: fixedContent,
        }));

        // if (isSubmitted && content.trim() !== "") {
        //   setErrors((prevErrors) => {
        //     const newErrors = { ...prevErrors };
        //     delete newErrors.description;
        //     return newErrors;
        //   });

        //   setInputState((prev) => ({
        //     ...prev,
        //     description: true,
        //   }));
        // }

        const plainText = fixedContent
            ?.replace(/<(.|\n)*?>/g, "")
            .replace(/&nbsp;/g, "")
            .trim();

        if (isSubmitted) {

            if (plainText) {

                setErrors((prevErrors) => {
                    const newErrors = { ...prevErrors };
                    delete newErrors.description;
                    return newErrors;
                });

                setInputState((prev) => ({
                    ...prev,
                    description: true,
                }));

            } else {

                setErrors((prevErrors) => ({
                    ...prevErrors,
                    description: "Description is required!",
                }));

                setInputState((prev) => ({
                    ...prev,
                    description: "",
                }));

            }
        }
    };

    useEffect(() => {
        if (inputValues.length === 0) {
            applyVariablesToEditor(editorContent, variables);
        }
    }, [inputValues]);

    const applyVariablesToEditor = (baseContent, variableList) => {
        let updatedContent = baseContent;
        const validLabels = [];

        const activeKeys = variableList
            .map((v) => `{{${v.var_key?.trim()}}}`)
            .filter(Boolean);

        const activeLabels = variableList
            .map((v) => v.var_name?.trim())
            .filter(Boolean);

        const allMatches = updatedContent.match(/{{\d+}}/g);
        if (allMatches) {
            allMatches.forEach((match) => {
                if (!activeKeys.includes(match)) {
                    const regex = new RegExp(
                        match.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
                        "g"
                    );
                    updatedContent = updatedContent.replace(regex, "");
                }
            });
        }

        setEditorContent(updatedContent);

        if (quillRef.current) {
            quillRef.current.setHTML(updatedContent);
        }

        setAddedValues(validLabels);
        setLetterFormat((prevData) => ({
            ...prevData,
            description: updatedContent,
        }));
    };

    const handleVariableChange = (index, field, value) => {
        const updated = variables.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );

        setVariables(updated);
        setLetterFormat((prevData) => ({
            ...prevData,
            letter_format_variables: updated,
        }));

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[`letter_format_variables[${index}].var_key`];
            delete updatedErrors[`letter_format_variables[${index}].var_name`];
            return updatedErrors;
        });
    };

    const handleRemoveVariable = (index) => {
        const newVars = [...variables];
        newVars.splice(index, 1);

        setVariables(newVars);

        setLetterFormat((prevData) => ({
            ...prevData,
            letter_format_variables: newVars,
        }));

        applyVariablesToEditor(editorContent, newVars);
    };

    const handleAddVariableClick = () => {
        if (!isEditorFocused) {
            toast.warning("Please click inside the editor before adding variables.");
            return;
        }
        handleAddVariable();
    };

    const handleAddVariable = () => {
        if (!quillRef.current) return;

        const nextKey = getNextKey(activeVariableIndex).toString();
        quillRef.current.insertVariable(nextKey);

        const newVariable = { var_key: nextKey, var_name: "", var_value: "" };
        const newVariables = [
            ...activeVariableIndex.map((v) => ({ ...v })),
            newVariable,
        ];

        setActiveVariableIndex(newVariables);
        setVariables(newVariables);
        setLetterFormat((prevData) => ({
            ...prevData,
            letter_format_variables: newVariables,
        }));

        const currentContent = quillRef.current.getHTML();
        setTemplateContent(currentContent);
        setEditorContent(currentContent);
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "letter_template",
            "sub_company",
            "letter_name",
            "subject",
            "description",
            "line_height",
            "letter_type",
        ];

        // requiredFields.forEach((field) => {
        //   if (
        //     letterFormat[field] === null ||
        //     letterFormat[field] === undefined ||
        //     letterFormat[field] === ""
        //   ) {
        //     newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
        //       } is required!`;
        //   }
        // });

        requiredFields.forEach((field) => {

            //  Special validation for ReactQuill description
            if (field === "description") {

                const plainText = letterFormat.description
                    ?.replace(/<(.|\n)*?>/g, "")
                    .replace(/&nbsp;/g, "")
                    .trim();

                if (!plainText) {
                    newErrors.description = "Description is required!";
                }

            } else {

                if (
                    letterFormat[field] === null ||
                    letterFormat[field] === undefined ||
                    letterFormat[field] === ""
                ) {
                    newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                        } is required!`;
                }

            }

        });

        //  UPDATED: Rating only required for warning & appreciation (1–5)
        // if (["warning", "appreciation"].includes(letterFormat.letter_type)) {
        //   if (
        //     letterFormat.letter_rating === "" ||
        //     letterFormat.letter_rating === null ||
        //     letterFormat.letter_rating === undefined
        //   ) {
        //     newErrors.letter_rating = "Letter rating is required!";
        //   } else {
        //     const rating = Number(letterFormat.letter_rating);
        //     if (rating < 1 || rating > 5) {
        //       newErrors.letter_rating = "Rating must be between 1 and 5!";
        //     }
        //   }
        // }

        // if (["warning", "appreciation"].includes(letterFormat.issued_by)) {
        //   if (
        //     letterFormat.letter_rating === "" ||
        //     letterFormat.letter_rating === null ||
        //     letterFormat.letter_rating === undefined
        //   ) {
        //     newErrors.letter_rating = "Letter rating is required!";
        //   } else {
        //     const rating = parseFloat(letterFormat.letter_rating);
        //     if (isNaN(rating) || rating < 1 || rating > 5) {
        //       newErrors.letter_rating = "Rating must be between 1 and 5 (decimals allowed, e.g. 3.5)!";
        //     }
        //   }
        // }

        if (["warning", "appreciation"].includes(letterFormat.letter_type)) {
            if (!letterFormat.issued_by?.trim()) {
                newErrors.issued_by = "Please select Issued By!";
            }
        }

        // ✅ NEW: issued_by_detail required for informative & others
        if (["informative", "others"].includes(letterFormat.letter_type)) {
            if (!letterFormat.letter_type_detail?.trim()) {
                newErrors.letter_type_detail =
                    letterFormat.letter_type === "informative"
                        ? "Please select an informative type!"
                        : "Please specify the letter type!";
            }
        }

        // Variable validation — unchanged
        if (variables.length > 0) {
            variables.forEach((pair, index) => {
                if (!pair?.var_key?.trim()) {
                    newErrors[`letter_format_variables[${index}].var_key`] =
                        "Variable key is required!";
                }
                if (!pair?.var_name?.trim()) {
                    newErrors[`letter_format_variables[${index}].var_name`] =
                        "Variable value is required!";
                }
            });
        }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // const handleSubmit = async (e) => {
    //   e.preventDefault();
    //   if (validateForm()) {
    //     setLoading(true);

    //     const loadingToastId = toast.loading("Loading: Please wait...");

    //     try {
    //       let res;
    //       if (letterFormat?.id) {
    //         const { format_variables, ...rest } = letterFormat;
    //         res = await axios.put(
    //           `${BASE_URL}/wfm/letter-builder-formatwithvariables-update-delete/${letterFormat?.id}/`,
    //           rest
    //         );
    //       }
    //       if (res.status === 200 || res.status === 201) {
    //         await getLetterFormatsData();
    //         setShow(false);
    //         toast.success("Letter format updated successfully!");
    //       } else {
    //         alert(res);
    //       }
    //     } catch (err) {
    //       handleErrorToast(err, loadingToastId);
    //     } finally {
    //       setLoading(false);
    //       toast.dismiss(loadingToastId);
    //     }
    //   }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");

            try {

                // ✅ PREPARE PAYLOAD
                const payload = {
                    ...letterFormat,
                };

                // ✅ HANDLE INFORMATIVE TYPE
                if (payload.letter_type === "informative") {

                    payload.informative_details =
                        payload.letter_type_detail;

                    payload.other_details = "";

                }

                // ✅ HANDLE OTHERS TYPE
                else if (payload.letter_type === "others") {

                    payload.other_details =
                        payload.letter_type_detail;

                    payload.informative_details = "";

                }

                // ✅ REMOVE FOR OTHER TYPES
                else {

                    payload.informative_details = "";
                    payload.other_details = "";

                }

                // ✅ REMOVE TEMP FIELD
                delete payload.letter_type_detail;

                let res;

                if (payload?.id) {

                    const { format_variables, ...rest } = payload;

                    res = await axios.put(
                        `${BASE_URL}/wfm/letter-builder-formatwithvariables-update-delete/${payload?.id}/`,
                        rest
                    );

                }

                if (res.status === 200 || res.status === 201) {

                    await getLetterFormatsData();

                    setShow(false);

                    toast.success("Letter format updated successfully!");

                } else {

                    alert(res);

                }

            } catch (err) {

                handleErrorToast(err, loadingToastId);

            } finally {

                setLoading(false);

                toast.dismiss(loadingToastId);

            }
        }
    };

    useEffect(() => {
        if (!show) return;

        if (letterFormat?.letter_format_variables?.length > 0) {
            const initial = {};
            letterFormat.letter_format_variables.forEach((v, i) => {
                initial[i] = v.var_name || "";
            });

            setInputState(initial);
            setInputValues(initial);
            setVariables(letterFormat.letter_format_variables);
            setActiveVariableIndex(letterFormat.letter_format_variables);
        }
    }, [letterFormat, show]);



    return (
        <>
            {i?.id && (
                <button
                    title="Update Letter Template"
                    className="model-edit-button-ml"
                    onClick={handleShow}
                >
                    <UpdatePencil />
                </button>
            )}

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Update Letter Format Builder -{" "}
                        <span className="dynamic-modal-title">
                            "{letterFormat?.letter_name}"
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                <div className="form-flex-wrap">
                                    {SUPER_ADMIN && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Sub Company<span className="required">*</span>
                                            </label>
                                            <select
                                                name="sub_company"
                                                value={letterFormat.sub_company}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.sub_company
                                                    ? "error"
                                                    : inputState.sub_company
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select a Company</option>
                                                {SUB_COMPANIES.map((i, index) => (
                                                    <option key={index} value={i.id}>
                                                        {i.title}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text">
                                                    {errors.sub_company}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Letter Templates<span className="required">*</span>
                                        </label>
                                        {buffer1 ? (
                                            <div className="form-loader">
                                                <div className="bar-loader"></div>
                                            </div>
                                        ) : (
                                            <select
                                                name="letter_template"
                                                value={letterFormat?.letter_template}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.letter_template
                                                    ? "error"
                                                    : inputState.letter_template
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select a Template</option>
                                                {lettersTemplate.map((i, index) => (
                                                    <option key={index} value={i.id}>
                                                        {i.template_name}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                        {errors.letter_template && (
                                            <span className="error-message font-size-text">
                                                {errors.letter_template}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Letter Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="letter_name"
                                            value={letterFormat?.letter_name}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.letter_name
                                                ? "error"
                                                : inputState.letter_name
                                                    ? "success"
                                                    : ""
                                                }`}
                                            placeholder="Letter Name"
                                            required
                                        />
                                        {errors.letter_name && (
                                            <span className="error-message font-size-text">
                                                {errors.letter_name}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Subject<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="subject"
                                            value={letterFormat?.subject}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.subject
                                                ? "error"
                                                : inputState.subject
                                                    ? "success"
                                                    : ""
                                                }`}
                                            placeholder="Letter Subject"
                                            required
                                        />
                                        {errors.subject && (
                                            <span className="error-message font-size-text">
                                                {errors.subject}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Line Height<span className="required">*</span>
                                        </label>
                                        <select
                                            name="line_height"
                                            value={letterFormat.line_height || "1.5"}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.line_height
                                                ? "error"
                                                : inputState.line_height
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        >
                                            <option value="">Select Line Height</option>
                                            {lineHeightOptions.map((item) => (
                                                <option key={item.value} value={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.line_height && (
                                            <span className="error-message font-size-text">
                                                {errors.line_height}
                                            </span>
                                        )}
                                    </div>

                                    {/*  UPDATED: Letter Type — new 4 options */}
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Letter Type<span className="required">*</span>
                                        </label>
                                        <select
                                            name="letter_type"
                                            value={letterFormat?.letter_type}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.letter_type
                                                ? "error"
                                                : inputState.letter_type
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        >
                                            <option value="">Select Letter Type</option>
                                            <option value="warning">Warning Letter</option>
                                            <option value="appreciation">Appreciation</option>
                                            <option value="informative">Informative</option>
                                            <option value="others">Others</option>
                                        </select>
                                        {errors.letter_type && (
                                            <span className="error-message font-size-text">
                                                {errors.letter_type}
                                            </span>
                                        )}
                                    </div>

                                    {/* ✅ NEW: Issued By dropdown */}
                                    {["warning", "appreciation"].includes(letterFormat.letter_type) && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Issued By<span className="required">*</span>
                                            </label>
                                            <select
                                                name="issued_by"
                                                value={letterFormat?.issued_by}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.issued_by
                                                    ? "error"
                                                    : inputState.issued_by
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select Issued By</option>
                                                {letterFormat.letter_type === "appreciation" && (
                                                    <>
                                                        <option value="client_appreciation">By Client</option>
                                                        <option value="team_appreciation">By Team</option>
                                                    </>
                                                )}
                                                {letterFormat.letter_type === "warning" && (
                                                    <>
                                                        <option value="client_warning">By Client</option>
                                                        <option value="team_warning">By Team</option>
                                                        <option value="pip">PIP</option>
                                                    </>
                                                )}
                                            </select>
                                            {errors.issued_by && (
                                                <span className="error-message font-size-text">
                                                    {errors.issued_by}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    {/* ✅ UPDATED: Rating — commented out */}
                                    {/* {["warning", "appreciation"].includes(
                    letterFormat.letter_type
                  ) && (
                      <div className="flex-column">
                        <label className="form-labels font-weight500 font-size-subheading">
                          Letter Rating (1-5)<span className="required">*</span>
                        </label>
                        <input
                          type="number"
                          name="letter_rating"
                          placeholder="e.g. 3.5 (between 1 and 5)"
                          id="letter_rating"
                          min={1}
                          max={5}
                          step={0.1}
                          value={letterFormat.letter_rating}
                          onChange={handleInputChange}
                          onWheel={(e) => e.target.blur()}
                          className={`form-input ${errors.letter_rating
                            ? "error"
                            : inputState.letter_rating
                              ? "success"
                              : ""
                            }`}
                          required
                        />
                        {errors.letter_rating && (
                          <span className="error-message font-size-text">
                            {errors.letter_rating}
                          </span>
                        )}
                      </div>
                    )} */}

                                    {/*  NEW: Informative sub-type dropdown */}
                                    {letterFormat.letter_type === "informative" && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Informative Type<span className="required">*</span>
                                            </label>
                                            <select
                                                name="letter_type_detail"
                                                value={letterFormat.letter_type_detail}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.letter_type_detail
                                                    ? "error"
                                                    : inputState.letter_type_detail
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select Informative Type</option>
                                                {informativeTypeOptions.map((opt) => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.letter_type_detail && (
                                                <span className="error-message font-size-text">
                                                    {errors.letter_type_detail}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    {/* ✅ NEW: Others — free text input */}
                                    {letterFormat.letter_type === "others" && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Specify Letter Type<span className="required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="letter_type_detail"
                                                placeholder="e.g. Exit Clearance, NOC, etc."
                                                value={letterFormat.letter_type_detail}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.letter_type_detail
                                                    ? "error"
                                                    : inputState.letter_type_detail
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            />
                                            {errors.letter_type_detail && (
                                                <span className="error-message font-size-text">
                                                    {errors.letter_type_detail}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Description & Editor — unchanged */}
                                <div className="form-flex-wrap">
                                    <div className="flex-row mb-2">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Description<span className="required">*</span>
                                        </label>
                                        <CustomTooltip
                                            position="right"
                                            tooltipContent={toolTipContent}
                                        >
                                            <span>
                                                <InfoIcon />
                                            </span>
                                        </CustomTooltip>
                                    </div>
                                    <div className="flex-column"></div>
                                </div>

                                <TipTapLetterEditor
                                    ref={quillRef}
                                    value={editorContent}
                                    onChange={onEditorContentChange}
                                    onFocus={() => setIsEditorFocused(true)}
                                    onBlur={() => setIsEditorFocused(false)}
                                    className={`builder-quill-editor form-input ${errors.description
                                        ? "error"
                                        : inputState.description
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.description && (
                                    <span className="error-message font-size-text">
                                        {errors.description}
                                    </span>
                                )}

                                {/* Add Variables — unchanged */}
                                <div className="form-flex-wrap">
                                    <div className="flex-row">
                                        <button
                                            type="button"
                                            title="Add Variables"
                                            className="upload-svg"
                                            onMouseDown={(e) => { e.preventDefault(); handleAddVariableClick(); }}
                                        >
                                            <AddwithWhiteCircle />
                                            Add Variables
                                        </button>
                                    </div>
                                </div>

                                {activeVariableIndex &&
                                    activeVariableIndex
                                        ?.sort((a, b) => a.var_key - b.var_key)
                                        .map((pair, index) => (
                                            <div key={index} className="variable-container">
                                                <div
                                                    style={{ marginBottom: "0px" }}
                                                    className="key-value-row"
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-input small-input"
                                                        placeholder="Key (e.g. {{1}})"
                                                        value={pair?.var_key}
                                                        onChange={(e) =>
                                                            handleVariableChange(
                                                                index,
                                                                "var_key",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                    {/* <CreatableSelect
                            options={staticVariableOptions}
                            value={
                              inputValues[index]
                                ? {
                                  label: inputValues[index],
                                  value: inputValues[index],
                                }
                                : null
                            }
                            onChange={(option) =>
                              handleVariableChange(
                                index,
                                "var_name",
                                option ? option.value : ""
                              )
                            }
                            onInputChange={(inputValue, actionMeta) => {
                              if (actionMeta.action === "input-change") {
                                handleVariableChange(
                                  index,
                                  "var_name",
                                  inputValue
                                );
                              }
                            }}
                            placeholder="Value (e.g. Name)"
                            isClearable
                            styles={CSSForSelect}
                          /> */}
                                                    <Select
                                                        options={staticVariableOptions}
                                                        value={
                                                            inputValues[index]
                                                                ? staticVariableOptions.find(
                                                                    (opt) => opt.value === inputValues[index]
                                                                ) || null
                                                                : null
                                                        }
                                                        onChange={(option) => {
                                                            const val = option ? option.value : "";
                                                            setInputValues((prev) => ({ ...prev, [index]: val }));
                                                            handleVariableChange(index, "var_name", val);
                                                        }}
                                                        placeholder="Value (e.g. Name)"
                                                        isClearable
                                                        styles={CSSForSelect}
                                                    />
                                                    <button
                                                        className="remove-btn"
                                                        type="button"
                                                        onClick={() => handleRemoveVariable(index)}
                                                        title="Remove"
                                                    >
                                                        <CrosswithGreyCircle />
                                                    </button>
                                                </div>
                                                {errors[
                                                    `letter_format_variables[${index}].var_key`
                                                ] && (
                                                        <span className="error-message font-size-text">
                                                            {
                                                                errors[
                                                                `letter_format_variables[${index}].var_key`
                                                                ]
                                                            }
                                                        </span>
                                                    )}
                                                {errors[
                                                    `letter_format_variables[${index}].var_name`
                                                ] && (
                                                        <span className="error-message font-size-text">
                                                            {
                                                                errors[
                                                                `letter_format_variables[${index}].var_name`
                                                                ]
                                                            }
                                                        </span>
                                                    )}
                                            </div>
                                        ))}

                                {/* Employee letter count warning — unchanged */}
                                {letterFormat?.employee_letter_count > 0 && (
                                    <div className="flex-column" style={{ marginTop: "5px" }}>
                                        <label
                                            className="form-labels font-weight500 flex item-center gap-1 font-size-subheading"
                                            style={{ marginTop: "5px" }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={variableConfirmation}
                                                onChange={(e) =>
                                                    setVariableConfirmation(e.target.checked)
                                                }
                                            />
                                            <span style={{ color: "red" }}>
                                                {`Note: This letter content was used in ${letterFormat?.employee_letter_count
                                                    } employee${letterFormat.employee_letter_count > 1 ? "s" : ""
                                                    } letter${letterFormat.employee_letter_count > 1 ? "s" : ""
                                                    }. Please confirm you still want to edit the letter Content.`}
                                            </span>
                                        </label>
                                    </div>
                                )}

                                {/* Buttons — unchanged */}
                                <div className="button-models">
                                    <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}
                                    >
                                        Cancel
                                    </button>

                                    <ViewLetterBuilder
                                        templateID={letterFormat.letter_template}
                                        formatData={letterFormat}
                                    />

                                    <button
                                        type="submit"
                                        className={`${letterFormat?.employee_letter_count > 0 &&
                                            !variableConfirmation
                                            ? "model-button model-button-cancel font-weight500"
                                            : "model-button model-button-leave font-weight500 font-size-heading"
                                            }`}
                                        disabled={
                                            loading ||
                                            (letterFormat?.employee_letter_count > 0 &&
                                                !variableConfirmation)
                                        }
                                        onClick={handleSubmit}
                                    >
                                        {letterFormat?.employee_letter_count > 0
                                            ? variableConfirmation
                                                ? "Update Letter Format"
                                                : "Confirmation Needed"
                                            : "Update Letter Format"}
                                    </button>
                                </div>
                            </form>
                        </div>

                        {/* Error summary — unchanged */}
                        <p className="error-message font-size-text">
                            {isSubmitted &&
                                Object.keys(errors).length > 0 &&
                                (Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">
                                        Please fill all mandatory fields!
                                    </h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, " ")
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(", ") + " are required!"}
                                    </h6>
                                ))}
                        </p>
                    </div>
                </Modal.Body>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Modal>
        </>
    );
};

const LetterFormatDelete = ({ i, getLetterFormatsData }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/letter-builder-formatwithvariables-update-delete/${i.id}/`
            );
            if (res.status === 200) {
                await getLetterFormatsData();
                setShow(false);
                toast.success(i?.id && "Letter Format Deleted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Letter Format </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to Delete Letter Format of{" "}
                        <b>{i?.letter_name}</b>
                        <div className="button-models">
                            <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};



const AddEmployeeLetter = ({
    getEmployeeLettersData,
    SUB_COMPANIES,
    SUPER_ADMIN,
    letterName,
}) => {
    const [show, setShow] = useState(false);

    const [lettersTemplate, setLettersTemplateData] = useState([]);
    const [lettersFormat, setLettersFormatData] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [buffer3, setBuffering3] = useState(true);
    const [templateData, setTemplateData] = useState();
    const [formatData, setFormatData] = useState();

    const [empList, setEmpList] = useState([]);

    // ─── Sending By (official from-mail) ─────────────────────────────────────
    // const [sendingByOptions, setSendingByOptions] = useState([]);
    // const [selectedSendingBy, setSelectedSendingBy] = useState(null);
    // const [bufferSendingBy, setBufferSendingBy] = useState(false);


    // ─── Additional external recipients (outside employee list) ───────────────
    const [additionalRecipients, setAdditionalRecipients] = useState([]);


    // ─── Search/filter state for the table ───────────────────────────────────
    const [empSearch, setEmpSearch] = useState("");

    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const baseUrl = urlParts[0] + `//` + urlParts[2];

    // ─── Multi-employee map: { [emp_code]: { ...empData } } ──────────────────
    const [empDataMap, setEmpDataMap] = useState({});

    // ─── Initial form state ───────────────────────────────────────────────────
    const initialEmployeeLetterData = {
        sub_company: sessionStorage.getItem("company_id"),
        letter_template: "",
        letter_content: "",
        emp_code: [],
        employee_letter_variables: [],
        email_sent: false,
        email_subject: "",
        email_body: "",
        email_documents: [],
        url: baseUrl,
        email_cc: [],
        // sending_by: "",
        additional_recipients: [],
        email_bcc: [],
    };

    const [formData, setFormData] = useState(initialEmployeeLetterData);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    // ─── Per-employee variable errors: { [emp_code]: ["var_name1", ...] } ────
    // Populated by validateForm; used to highlight table rows + show summary
    const [variableErrors, setVariableErrors] = useState({});

    // ─── react-select for CC only now ─────────────────────────────────────────
    const [selectedCCOptions, setSelectedCCOptions] = useState([]);
    const [selectedBCCOptions, setSelectedBCCOptions] = useState([]);

    // Quill editor
    const [editorContent, setEditorContent] = useState("");
    const quillRef = useRef(null);

    // ─── Open / Close ─────────────────────────────────────────────────────────
    const resetAll = () => {
        setFormData(initialEmployeeLetterData);
        setErrors({});
        setInputState({});
        setEditorContent("");
        setFormatData(null);
        setTemplateData(null);
        setEmpDataMap({});
        setSelectedCCOptions([]);
        setEmpSearch("");
        setVariableErrors({});
        // setSelectedSendingBy(null);
        setAdditionalRecipients([]);
        setSelectedBCCOptions([]);
    };

    const handleClose = () => {
        setShow(false);
        resetAll();
    };

    const handleShow = () => {
        resetAll();
        getLetterTemplatesList();
        getLetterFormatsList();
        getAllEmpCodes();
        // getOfficialMailAccounts();
        setShow(true);
    };

    // ─── Data fetchers ────────────────────────────────────────────────────────
    // subCompanyId param: always pass the latest value directly so we never
    // read stale formData.sub_company from the closure (React state is async).
    const getAllEmpCodes = async (subCompanyId) => {
        const id = subCompanyId ?? formData.sub_company;
        if (!id) return;
        setBuffering1(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${id}/`
            );
            setEmpList(customSortByKey(res.data, "emp_code"));
        } catch (err) {
        } finally {
            setBuffering1(false);
        }
    };

    // const getOfficialMailAccounts = async (subCompanyId) => {
    //   const id = subCompanyId ?? formData.sub_company;
    //   if (!id) return;
    //   setBufferSendingBy(true);
    //   try {
    //     const res = await axios.get(
    //       `${BASE_URL}/wfm/official-mail-accounts/${id}/`

    //     );

    //     setSendingByOptions(
    //       res.data.map((acc) => ({
    //         value: acc.id,          // or acc.email depending on what backend expects
    //         label: acc.display_name
    //           ? `${acc.display_name} <${acc.email}>`
    //           : acc.email,
    //         email: acc.email,
    //       }))
    //     );
    //   } catch (err) {
    //     handleErrorToast(err);
    //   } finally {
    //     setBufferSendingBy(false);
    //   }
    // };

    const getLetterTemplatesList = async (subCompanyId) => {
        const id = subCompanyId ?? formData.sub_company;
        if (!id) return;
        setBuffering2(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/letter-builder-template-bysubcompany/${id}/`
            );
            setLettersTemplateData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering2(false);
        }
    };

    const getLetterFormatsList = async (subCompanyId) => {
        const id = subCompanyId ?? formData.sub_company;
        if (!id) return;
        setBuffering3(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/letter-builder-formatwithvariables-bysubcompany/${id}/`
            );
            setLettersFormatData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering3(false);
        }
    };

    const getEmpDetails = async (empCode) => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanydetailsbyemp/${empCode}/`
            );
            return res.data;
        } catch (err) {
            console.log(err);
            return {};
        }
    };

    const getLetterTemplateByID = async (id) => {
        if (!id) return;
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/letter-builder-template-byid/${id}/`
            );
            setTemplateData(res?.data);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setBuffering(false);
        }
    };

    const getLetterFormatByID = async (id) => {
        if (!id) return;
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/letter-builder-formatwithvariables-byid/${id}/`
            );
            setFormatData(res?.data);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setBuffering(false);
        }
    };

    // ─── Rebuild per-employee variable data (silently) ────────────────────────
    // No UI shown for this — auto-populated from API data
    const rebuildLetterData = (codes, dataMap, variables) => {
        setFormData((prev) => {
            const existingDataMap = {};
            (prev.employee_letter_variables || []).forEach((entry) => {
                existingDataMap[entry.emp_code] = entry.variables;
            });

            const newLetterData = codes.map((code) => {
                const empData = dataMap[code] || {};
                const existingVars = existingDataMap[code];

                const variables_filled = variables.map((pair) => {
                    const existingVal = existingVars?.find(
                        (v) => v.var_key === pair.var_key
                    )?.var_value;
                    const autoVal = getEmpDataValue(empData, pair.var_name);
                    return {
                        var_key: pair.var_key,
                        var_name: pair.var_name,
                        // Prefer auto-populated value from API; keep existing only if already set
                        var_value:
                            existingVal !== undefined && existingVal !== ""
                                ? existingVal
                                : autoVal || "",
                    };
                });

                return { emp_code: code, variables: variables_filled };
            });

            return { ...prev, employee_letter_variables: newLetterData };
        });
    };

    // ─── Rebuild when formatData changes ──────────────────────────────────────
    useEffect(() => {
        if (!formatData?.letter_format_variables || !show) return;
        const codes = formData.emp_code || [];
        if (codes.length === 0) return;
        rebuildLetterData(codes, empDataMap, formatData.letter_format_variables);
    }, [formatData, show]);

    // ─── Table-based employee selection handlers ──────────────────────────────

    // Filtered list for the table based on search


    const filteredEmpList = empList.filter((emp) => {
        const search = empSearch.toLowerCase();

        return (
            emp.emp_code?.toLowerCase().includes(search) ||
            emp.name?.toLowerCase().includes(search) ||
            emp.email?.toLowerCase().includes(search)
        );
    });

    const isEmpSelected = (empCode) => formData.emp_code.includes(empCode);

    // Toggle a single employee row
    const handleRowToggle = async (emp) => {
        const alreadySelected = isEmpSelected(emp.emp_code);
        let newCodes;
        let updatedMap = { ...empDataMap };

        if (alreadySelected) {
            // Deselect — remove from codes and map
            newCodes = formData.emp_code.filter((c) => c !== emp.emp_code);
            delete updatedMap[emp.emp_code];
        } else {
            // Select — add to codes, fetch data if not yet loaded
            newCodes = [...formData.emp_code, emp.emp_code];
            if (!updatedMap[emp.emp_code]) {
                const data = await getEmpDetails(emp.emp_code);
                updatedMap[emp.emp_code] = data;
            }
        }

        setEmpDataMap(updatedMap);
        setFormData((prev) => ({ ...prev, emp_code: newCodes }));

        if (formatData?.letter_format_variables) {
            rebuildLetterData(newCodes, updatedMap, formatData.letter_format_variables);
        }
    };

    const handleChangeBCC = (selected) => {
        setSelectedBCCOptions(selected || []);
        setFormData((prev) => ({
            ...prev,
            email_bcc: (selected || []).map((item) => item.value),
        }));
    };

    // Select / Deselect all visible (filtered) employees
    const allFilteredSelected =
        filteredEmpList.length > 0 &&
        filteredEmpList.every((emp) => isEmpSelected(emp.emp_code));

    const handleSelectAll = async (e) => {
        const updatedMap = { ...empDataMap };

        if (e.target.checked) {
            // Add all filtered employees not yet selected
            const toAdd = filteredEmpList.filter((emp) => !isEmpSelected(emp.emp_code));

            // Fetch data for new ones in parallel
            await Promise.all(
                toAdd.map(async (emp) => {
                    if (!updatedMap[emp.emp_code]) {
                        const data = await getEmpDetails(emp.emp_code);
                        updatedMap[emp.emp_code] = data;
                    }
                })
            );

            const newCodes = [
                ...new Set([
                    ...formData.emp_code,
                    ...filteredEmpList.map((e) => e.emp_code),
                ]),
            ];

            setEmpDataMap(updatedMap);
            setFormData((prev) => ({ ...prev, emp_code: newCodes }));

            if (formatData?.letter_format_variables) {
                rebuildLetterData(newCodes, updatedMap, formatData.letter_format_variables);
            }
        } else {
            // Deselect all filtered employees
            const filteredCodes = filteredEmpList.map((e) => e.emp_code);
            const remainingCodes = formData.emp_code.filter(
                (c) => !filteredCodes.includes(c)
            );
            filteredCodes.forEach((c) => delete updatedMap[c]);

            setEmpDataMap(updatedMap);
            setFormData((prev) => ({ ...prev, emp_code: remainingCodes }));

            if (formatData?.letter_format_variables) {
                rebuildLetterData(remainingCodes, updatedMap, formatData.letter_format_variables);
            }
        }
    };

    // ─── Generic input handlers ───────────────────────────────────────────────
    const handleSubCompanyInputChange = (e) => {
        const { name, value } = e.target;
        setInputState((prev) => ({ ...prev, [name]: value.trim() ? "green" : "" }));

        // Reset all sub-company-dependent selections when company changes
        setFormData((prev) => ({
            ...prev,
            [name]: value,
            letter_template: "",
            letter_content: "",
            emp_code: [],
            employee_letter_variables: [],
            // sending_by: "",
            additional_recipients: [],
        }));
        // setSelectedSendingBy(null);
        setAdditionalRecipients([]);
        setEmpDataMap({});
        setVariableErrors({});
        setEmpSearch("");

        if (value.trim()) {
            setErrors((prev) => {
                const u = { ...prev };
                delete u[name];
                return u;
            });
        }

        // Pass `value` directly — formData.sub_company is still the old value here
        getLetterTemplatesList(value);
        getLetterFormatsList(value);
        getAllEmpCodes(value);
        // getOfficialMailAccounts(value);
    };


    // ─── Sending By handler ───────────────────────────────────────────────────
    // const handleSendingByChange = (selected) => {
    //   setSelectedSendingBy(selected || null);
    //   setFormData((prev) => ({
    //     ...prev,
    //     sending_by: selected?.value || "",
    //   }));
    //   if (selected) {
    //     setErrors((prev) => { const u = { ...prev }; delete u.sending_by; return u; });
    //   }
    // };

    // ─── Additional recipients handler (CreatableSelect) ─────────────────────
    const handleAdditionalRecipientsChange = (selected) => {
        setAdditionalRecipients(selected || []);
        setFormData((prev) => ({
            ...prev,
            additional_recipients: (selected || []).map((s) => s.value),
        }));
    };

    // Simple email format validator for CreatableSelect
    const isValidEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "email_sent") {
            setFormData((prev) => ({
                ...prev,
                email_sent: checked,
                ...(!checked && {
                    email_subject: "",
                    email_body: "",
                    email_documents: [],
                }),
            }));
            if (!checked) setEditorContent("");
            return;
        }

        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
        setInputState((prev) => ({ ...prev, [name]: value.trim() ? "green" : "" }));
        if (value && value.toString().trim()) {
            setErrors((prev) => {
                const u = { ...prev };
                delete u[name];
                return u;
            });
        }

        if (name === "letter_template") getLetterTemplateByID(value);
        if (name === "letter_content") getLetterFormatByID(value);
    };

    // ─── CC handler ───────────────────────────────────────────────────────────
    const handleChangeCC = (selected) => {
        setSelectedCCOptions(selected || []);
        setFormData((prev) => ({
            ...prev,
            email_cc: (selected || []).map((item) => item.value),
        }));
    };

    // ─── Quill editor ─────────────────────────────────────────────────────────
    const convertSpaces = (html) => html.replace(/  /g, "&nbsp;&nbsp;");

    const onEditorContentChange = (content) => {
        const fixed = convertSpaces(content).replace(
            /href="(?!http)([^"]+)"/g,
            'href="https://$1"'
        );
        setEditorContent(fixed);
        setFormData((prev) => ({ ...prev, email_body: fixed }));
        if (isSubmitted && content.trim()) {
            setErrors((prev) => {
                const u = { ...prev };
                delete u.email_body;
                return u;
            });
        }
    };

    // ─── Attachment handlers ──────────────────────────────────────────────────
    const handleChange = (e, index) => {
        const { name, value } = e.target;
        setFormData((prev) => {
            if (name === "email_subject" || name === "email_body") {
                return { ...prev, [name]: value };
            }
            if (name === "doc_name") {
                const docs = [...prev.email_documents];
                docs[index].doc_name = value;
                return { ...prev, email_documents: docs };
            }
            return prev;
        });
        if (name === "doc_name" && value.trim()) {
            setErrors((prev) => {
                const u = { ...prev };
                delete u[`email_documents[${index}].doc_name`];
                return u;
            });
        }
    };

    const handleFileChange = (e, index) => {
        const file = e.target.files[0];
        setFormData((prev) => {
            const docs = [...prev.email_documents];
            docs[index].doc_file = file;
            return { ...prev, email_documents: docs };
        });
        if (file) {
            setErrors((prev) => {
                const u = { ...prev };
                delete u[`email_documents[${index}].doc_file`];
                return u;
            });
        }
    };

    const handleFileClear = (index) => {
        setFormData((prev) => {
            const docs = [...prev.email_documents];
            docs[index] = { ...docs[index], doc_file: null };
            return { ...prev, email_documents: docs };
        });
    };

    const handleAddDocument = () => {
        setFormData((prev) => ({
            ...prev,
            email_documents: [
                ...prev.email_documents,
                { doc_name: "", doc_file: null },
            ],
        }));
    };

    const handleRemoveDocument = (index) => {
        setFormData((prev) => {
            const docs = [...prev.email_documents];
            docs.splice(index, 1);
            return { ...prev, email_documents: docs };
        });
    };

    // ─── Validation ───────────────────────────────────────────────────────────
    const validateForm = () => {
        const newErrors = {};

        if (!formData.letter_template)
            newErrors.letter_template = "Letter Template is required!";
        if (!formData.sub_company)
            newErrors.sub_company = "Sub Company is required!";
        if (!formData.letter_content)
            newErrors.letter_content = "Letter Content is required!";
        if (!formData.emp_code || formData.emp_code.length === 0)
            newErrors.emp_code = "At least one employee must be selected!";
        // if (!formData.sending_by) {
        //   newErrors.sending_by = "Please select an official mail account!";
        // }
        // ── Variable completeness check ──────────────────────────────────────────
        // For every selected employee, find any variable whose auto-populated
        // value is still empty and collect them so the user knows exactly what's
        // missing without having to hunt through a manual form.
        const newVariableErrors = {}; // { [emp_code]: ["var_name", ...] }

        formData.employee_letter_variables?.forEach((entry) => {
            const missing = entry.variables
                ?.filter((v) => !v.var_value || v.var_value.trim() === "")
                .map((v) => v.var_name);

            if (missing && missing.length > 0) {
                newVariableErrors[entry.emp_code] = missing;
            }
        });

        if (Object.keys(newVariableErrors).length > 0) {
            // One top-level error key so the global error summary also catches it
            newErrors.employee_letter_variables =
                "Some employees have missing variable values. Please check the highlighted rows below.";
        }

        if (formData.email_sent) {
            if (!formData.email_subject)
                newErrors.email_subject = "Email subject is required!";
            if (!formData.email_body)
                newErrors.email_body = "Email body is required!";

            formData.email_documents?.forEach((doc, i) => {
                if (!doc.doc_name)
                    newErrors[`email_documents[${i}].doc_name`] = "Document name is required!";
                if (!doc.doc_file)
                    newErrors[`email_documents[${i}].doc_file`] = "Document file is required!";
            });
        }

        setVariableErrors(newVariableErrors);
        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // ─── Submit ───────────────────────────────────────────────────────────────
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const formDataToSend = new FormData();

            formData.email_documents.forEach((doc, i) => {
                if (doc.doc_file) {
                    formDataToSend.append(`email_documents[${i}][doc_name]`, doc.doc_name);
                    formDataToSend.append(`email_documents[${i}][doc_file]`, doc.doc_file);
                }
            });

            formDataToSend.append("sub_company", formData.sub_company);
            formDataToSend.append("letter_template", formData.letter_template);
            formDataToSend.append("letter_content", formData.letter_content);
            formDataToSend.append("email_sent", formData.email_sent);
            formDataToSend.append("email_subject", formData.email_subject || "");
            formDataToSend.append("email_body", formData.email_body || "");
            formDataToSend.append("document_count", formData.email_documents.length);
            formDataToSend.append("url", formData.url);
            formDataToSend.append("email_cc", JSON.stringify(formData.email_cc || []));
            formDataToSend.append("email_bcc", JSON.stringify(formData.email_bcc || []));
            // formDataToSend.append("sending_by", formData.sending_by || "");
            formDataToSend.append(
                "additional_recipients",
                JSON.stringify(formData.additional_recipients || [])
            );
            // Multi-employee fields
            formDataToSend.append(
                "multiple_emp_code",
                JSON.stringify(formData.emp_code)
            );
            formDataToSend.append(
                "employee_letter_variables",
                JSON.stringify(formData.employee_letter_variables)
            );

            const res = await axios.post(
                `${BASE_URL}/wfm/letter-builder-send-mail-save-document/v2/`,
                formDataToSend,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (res.status === 200 || res.status === 201) {
                await getEmployeeLettersData();
                handleClose();
                toast.success(
                    `${formData.emp_code.length} Employee Letter(s) created successfully!`
                );
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    // ─── Derived option lists ─────────────────────────────────────────────────
    const ccSelectOptions = empList
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({ value: e.email, label: `${e.emp_code} - ${e.email}` }));

    // ─── Render ───────────────────────────────────────────────────────────────
    return (
        <>
            <button
                title="Add Employee Letter"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Employee Letter
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="five-sixth-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Add Employee Letter</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {/* ── Row 1: Company + Template + Content ── */}
                                <div className="form-flex-wrap">
                                    {SUPER_ADMIN && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Sub Company<span className="required">*</span>
                                            </label>
                                            <select
                                                name="sub_company"
                                                value={formData.sub_company}
                                                onChange={handleSubCompanyInputChange}
                                                className={`form-input ${errors.sub_company
                                                    ? "error"
                                                    : inputState.sub_company
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Company</option>
                                                {SUB_COMPANIES.map((i, idx) => (
                                                    <option key={idx} value={i.id}>
                                                        {i.title}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text">
                                                    {errors.sub_company}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Letter Template<span className="required">*</span>
                                        </label>
                                        {buffer2 ? (
                                            <div className="form-loader">
                                                <div className="bar-loader" />
                                            </div>
                                        ) : (
                                            <select
                                                name="letter_template"
                                                value={formData.letter_template}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.letter_template
                                                    ? "error"
                                                    : inputState.letter_template
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Template</option>
                                                {lettersTemplate.map((i, idx) => (
                                                    <option key={idx} value={i.id}>
                                                        {i.template_name}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                        {errors.letter_template && (
                                            <span className="error-message font-size-text">
                                                {errors.letter_template}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Letter Content<span className="required">*</span>
                                        </label>
                                        {buffer3 ? (
                                            <div className="form-loader">
                                                <div className="bar-loader" />
                                            </div>
                                        ) : (
                                            <select
                                                name="letter_content"
                                                value={formData.letter_content}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.letter_content
                                                    ? "error"
                                                    : inputState.letter_content
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select Content</option>
                                                {lettersFormat.map((i, idx) => (
                                                    <option key={idx} value={i.id}>
                                                        {i.letter_name}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                        {errors.letter_content && (
                                            <span className="error-message font-size-text">
                                                {errors.letter_content}
                                            </span>
                                        )}
                                    </div>

                                    {/* ---------------sending by email */}
                                    {/* ── Sending By (official from-mail account) ── */}
                                    {/* <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Sending By

                      <CustomTooltip position="top" tooltipContent="Employees will see this address as the sender and can reply to it">
                        <span style={{ marginLeft: '3px' }}>
                          <InfoIcon />
                        </span>
                      </CustomTooltip>
                 
                    </label>
                    {bufferSendingBy ? (
                      <div className="form-loader">
                        <div className="bar-loader" />
                      </div>
                    ) : (
                      <Select
                        options={sendingByOptions}
                        isClearable
                        placeholder="Select official mail account…"
                        value={selectedSendingBy}
                        onChange={handleSendingByChange}
                        styles={CSSForSelect}
                        noOptionsMessage={() =>
                          sendingByOptions.length === 0
                            ? "No official mail accounts configured"
                            : "No match"
                        }
                      />
                    )}
                    {errors.sending_by && (
                      <span className="error-message font-size-text">
                        {errors.sending_by}
                      </span>
                    )}
                  </div> */}
                                </div>

                                {/* ── Employee Table Selection  ── */}
                                <div className="flex-column" style={{ marginTop: "16px" }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Select Employees<span className="required">*</span>
                                            {formData.emp_code.length > 0 && (
                                                <span
                                                    style={{
                                                        marginLeft: "8px",
                                                        fontSize: "12px",
                                                        color: "#2576bc",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    ({formData.emp_code.length} selected)
                                                </span>
                                            )}
                                        </label>

                                        {/* Search input */}
                                        <input
                                            type="text"
                                            placeholder="Search by code/name/email"
                                            value={empSearch}
                                            onChange={(e) => setEmpSearch(e.target.value)}
                                            className="form-input-date"
                                            style={{ width: "250px" }}
                                        />
                                    </div>

                                    {errors.emp_code && (
                                        <span
                                            className="error-message font-size-text"
                                            style={{ marginBottom: "6px" }}
                                        >
                                            {errors.emp_code}
                                        </span>
                                    )}

                                    <div className="table-container">
                                        <table className="table-css">
                                            <thead>
                                                <tr className="custom-table-head-tr">
                                                    {/* Select All checkbox */}
                                                    <th className="table-heading align-center" style={{ width: "50px" }}>
                                                        <label
                                                            className="checkbox-click"
                                                            style={{ height: "16px" }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={allFilteredSelected}
                                                                onChange={handleSelectAll}
                                                                disabled={
                                                                    buffer1 || filteredEmpList.length === 0
                                                                }
                                                            />
                                                            <div className="checkmark-medium"></div>
                                                        </label>
                                                    </th>
                                                    <th className="table-heading align-center">
                                                        Employee Code
                                                    </th>
                                                    <th className="table-heading align-center">Name</th>
                                                    <th className="table-heading align-center">
                                                        Email
                                                    </th>
                                                    {formData.letter_content && (
                                                        <th className="table-heading align-center">
                                                            Preview
                                                        </th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody className="align-center">
                                                {buffer1 ? (
                                                    <tr>
                                                        <td colSpan={formData.letter_content ? "6" : "5"}>
                                                            <div className="form-loader">
                                                                <div className="bar-loader"></div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : filteredEmpList.length > 0 ? (
                                                    filteredEmpList.map((emp) => {
                                                        const selected = isEmpSelected(emp.emp_code);
                                                        const hasVarError =
                                                            isSubmitted &&
                                                            !!variableErrors[emp.emp_code]?.length;
                                                        return (
                                                            <tr
                                                                key={emp.emp_code}
                                                                className="custom-table-head-td"
                                                                onClick={() => handleRowToggle(emp)}
                                                                style={{
                                                                    cursor: "pointer",
                                                                    backgroundColor: hasVarError
                                                                        ? "#fff3f3"
                                                                        : selected
                                                                            ? "#e8f4fd"
                                                                            : "transparent",
                                                                    transition: "background-color 0.15s",
                                                                    outline: hasVarError
                                                                        ? "1px solid #ffb3b3"
                                                                        : "none",
                                                                }}
                                                            >
                                                                {/* Checkbox cell */}
                                                                <td
                                                                    className="align-center"
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <label
                                                                        className="checkbox-click"
                                                                        style={{ marginTop: "-3px" }}
                                                                    >
                                                                        <input
                                                                            className="form-checkbox-nm"
                                                                            type="checkbox"
                                                                            checked={selected}
                                                                            onChange={() => handleRowToggle(emp)}
                                                                        />
                                                                        <div className="checkmark-medium"></div>
                                                                    </label>
                                                                </td>
                                                                <td className="align-center">
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            gap: "6px",
                                                                        }}
                                                                    >
                                                                        {emp.emp_code}
                                                                        {hasVarError && (
                                                                            <span
                                                                                title={`Missing: ${variableErrors[emp.emp_code].join(", ")}`}
                                                                                style={{
                                                                                    backgroundColor: "#e74c3c",
                                                                                    color: "#fff",
                                                                                    borderRadius: "10px",
                                                                                    fontSize: "10px",
                                                                                    fontWeight: "600",
                                                                                    padding: "1px 6px",
                                                                                    whiteSpace: "nowrap",
                                                                                    cursor: "help",
                                                                                }}
                                                                            >
                                                                                ⚠ {variableErrors[emp.emp_code].length} missing
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td className="align-center">{emp.name}</td>
                                                                <td className="align-center">
                                                                    {emp.email || "-"}
                                                                </td>

                                                                {/* Preview cell — only when letter_content is chosen
                                    and this employee is selected (variables populated) */}
                                                                {formData.letter_content && (
                                                                    <td
                                                                        className="align-center"
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {selected ? (
                                                                            (() => {
                                                                                // Build per-employee empLetterData for ViewLetterBuilder.
                                                                                // ViewLetterBuilder reads empLetterData.employee_letter_variables
                                                                                // when empLetterID is not passed.
                                                                                const empVarEntry =
                                                                                    formData.employee_letter_variables?.find(
                                                                                        (entry) =>
                                                                                            entry.emp_code === emp.emp_code
                                                                                    );
                                                                                const perEmpLetterData = {
                                                                                    employee_letter_variables:
                                                                                        empVarEntry?.variables || [],
                                                                                };
                                                                                return (
                                                                                    <ViewLetterBuilder
                                                                                        buttonDisplay="Eye"
                                                                                        buttonDisplayName="Preview"
                                                                                        templateID={formData.letter_template}
                                                                                        formatID={formData.letter_content}
                                                                                        empLetterData={perEmpLetterData}
                                                                                    />
                                                                                );
                                                                            })()
                                                                        ) : (
                                                                            <span
                                                                                style={{
                                                                                    fontSize: "11px",
                                                                                    color: "#bbb",
                                                                                }}
                                                                            >
                                                                                —
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td
                                                            colSpan={formData.letter_content ? "6" : "5"}
                                                            className="align-center"
                                                        >
                                                            {empSearch
                                                                ? `No employees found for "${empSearch}"`
                                                                : "No employees available"}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/*
                   * ── Variable error summary (shown only after a failed submit) ──
                   * Lists each employee whose auto-populated variables are still
                   * empty, with the exact variable names that need attention.
                   * The user can deselect that employee or the backend data may
                   * need to be populated for the missing fields.
                   */}
                                    {isSubmitted && Object.keys(variableErrors).length > 0 && (
                                        <div
                                            style={{
                                                marginTop: "10px",
                                                border: "1px solid #ffb3b3",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff8f8",
                                                padding: "12px 16px",
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0 0 8px 0",
                                                    fontWeight: "600",
                                                    fontSize: "13px",
                                                    color: "#c0392b",
                                                }}
                                            >
                                                ⚠ Missing variable data for{" "}
                                                {Object.keys(variableErrors).length} employee(s) — these
                                                fields could not be auto-filled from employee records:
                                            </p>
                                            <ul
                                                style={{
                                                    margin: 0,
                                                    paddingLeft: "18px",
                                                    fontSize: "12px",
                                                    color: "#555",
                                                    lineHeight: "1.8",
                                                }}
                                            >
                                                {Object.entries(variableErrors).map(
                                                    ([empCode, missingVars]) => {
                                                        const empName = empList.find(
                                                            (e) => e.emp_code === empCode
                                                        )?.name;
                                                        return (
                                                            <li key={empCode}>
                                                                <strong style={{ color: "#c0392b" }}>
                                                                    {empCode}
                                                                    {empName ? ` – ${empName}` : ""}:
                                                                </strong>{" "}
                                                                {missingVars.join(", ")}
                                                            </li>
                                                        );
                                                    }
                                                )}
                                            </ul>
                                            <p
                                                style={{
                                                    margin: "8px 0 0 0",
                                                    fontSize: "11px",
                                                    color: "#888",
                                                }}
                                            >
                                                Tip: Ensure the employee profile has these fields filled,
                                                or deselect the employee to proceed without them.
                                            </p>
                                        </div>
                                    )}

                                    {/*
                   * ── "Variables per Employee" section is REMOVED ──
                   * Variables are silently auto-populated from ourcompanydetailsbyemp
                   * whenever an employee is selected. rebuildLetterData() handles this.
                   * The payload (employee_letter_variables) is built and sent automatically.
                   */}
                                </div>

                                {/* ── Email section ── */}
                                <div style={{ marginTop: "20px" }}>
                                    <div
                                        className="flex-row justify-evenly"
                                        style={{ width: "100%" }}
                                    >
                                        <div className="flex-row">
                                            <div className="checkbox-toggle">
                                                <input
                                                    type="checkbox"
                                                    name="email_sent"
                                                    checked={formData.email_sent}
                                                    onChange={handleInputChange}
                                                    id="email_sent"
                                                />
                                                <label htmlFor="email_sent" />
                                            </div>
                                            <hr className="field-cont-hr" />
                                            <label
                                                htmlFor="email_sent"
                                                className="font-weight500 font-size-subheading"
                                            >
                                                {formData.email_sent && formData.emp_code.length > 0
                                                    ? `Send mail to ${formData.emp_code.length} employee(s)`
                                                    : "Send Email"}
                                            </label>
                                        </div>
                                    </div>

                                    {formData.email_sent && (
                                        <div>
                                            <div className="form-flex-wrap">
                                                <div className="flex-column">
                                                    <label className="form-labels font-weight500 font-size-subheading">
                                                        Subject<span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-input emp-letter-form-input emp_email_input emp-letter-small-input"
                                                        placeholder="Subject"
                                                        value={formData.email_subject || ""}
                                                        name="email_subject"
                                                        onChange={handleInputChange}
                                                    />
                                                    {errors.email_subject && (
                                                        <span className="error-message font-size-text mt-0">
                                                            {errors.email_subject}
                                                        </span>
                                                    )}
                                                </div>

                                                {/* <div className="flex-column">
                          <label className="form-labels font-weight500 announce-date font-weight400 font-size-heading">
                            CC Mails
                          </label>
                          {buffer1 ? (
                            <div className="form-loader">
                              <div className="bar-loader" />
                            </div>
                          ) : (
                            <Select
                              options={ccSelectOptions}
                              isMulti
                              value={selectedCCOptions}
                              onChange={handleChangeCC}
                              styles={CSSForSelect}
                            />
                          )}
                        </div> */}

                                                <div className="flex-column">
                                                    <label className="form-labels font-weight500 announce-date font-weight400 font-size-heading">
                                                        CC Mails
                                                    </label>
                                                    {buffer1 ? (
                                                        <div className="form-loader">
                                                            <div className="bar-loader" />
                                                        </div>
                                                    ) : (
                                                        <CreatableSelect
                                                            options={ccSelectOptions}
                                                            isMulti
                                                            isClearable
                                                            value={selectedCCOptions}
                                                            onChange={handleChangeCC}
                                                            styles={CSSForSelect}
                                                            placeholder="Select or type an email…"
                                                            isValidNewOption={(inputValue) => isValidEmail(inputValue)}
                                                            formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                                            noOptionsMessage={() => "Type an email address to add"}
                                                        />
                                                    )}
                                                </div>

                                                <div className="flex-column">
                                                    <label className="form-labels font-weight500 announce-date font-weight400 font-size-heading">
                                                        BCC Mails
                                                    </label>
                                                    {buffer1 ? (
                                                        <div className="form-loader">
                                                            <div className="bar-loader" />
                                                        </div>
                                                    ) : (
                                                        <CreatableSelect
                                                            options={ccSelectOptions}
                                                            isMulti
                                                            isClearable
                                                            value={selectedBCCOptions}
                                                            onChange={handleChangeBCC}
                                                            styles={CSSForSelect}
                                                            placeholder="Select or type an email…"
                                                            isValidNewOption={(inputValue) => isValidEmail(inputValue)}
                                                            formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                                            noOptionsMessage={() => "Type an email address to add"}
                                                        />
                                                    )}
                                                </div>

                                                {/* ── Additional Recipients (external / non-employee emails) ── */}
                                                <div className="flex-column">
                                                    <label className="form-labels font-weight500 font-size-subheading">
                                                        Additional Recipients

                                                        <CustomTooltip position="top" tooltipContent="Send this email to people outside the employee list. Type an email and press Enter.">
                                                            <span style={{ marginLeft: '3px' }}>
                                                                <InfoIcon />
                                                            </span>
                                                        </CustomTooltip>

                                                    </label>
                                                    <CreatableSelect
                                                        isMulti
                                                        isClearable
                                                        placeholder="Type an email and press Enter…"
                                                        value={additionalRecipients}
                                                        onChange={handleAdditionalRecipientsChange}
                                                        styles={CSSForSelect}
                                                        isValidNewOption={(inputValue) => isValidEmail(inputValue)}
                                                        formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                                        noOptionsMessage={() => "Type an email address to add"}
                                                        components={{ DropdownIndicator: null }}
                                                    />
                                                    {additionalRecipients.length > 0 && (
                                                        <span style={{ fontSize: "11px", color: "#2576bc" }}>
                                                            {additionalRecipients.length} external recipient(s) will also receive this email
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="flex-column">
                                                <label className="form-labels font-weight500 font-size-subheading mb-3 mt-3">
                                                    Body<span className="required">*</span>
                                                </label>
                                                <TipTapEditor
                                                    ref={quillRef}
                                                    value={editorContent}
                                                    onChange={onEditorContentChange}
                                                    className="builder-quill-editor form-input"
                                                />
                                                {errors.email_body && (
                                                    <span className="error-message font-size-text mt-0">
                                                        {errors.email_body}
                                                    </span>
                                                )}
                                            </div>

                                            {/* Attachments */}
                                            <div className="flex-column">
                                                <div className="flex justify-between align-center">
                                                    <label className="form-labels font-weight500 font-size-subheading">
                                                        Attachment
                                                    </label>
                                                    <button
                                                        type="button"
                                                        title="Add attachment"
                                                        className="upload-svg"
                                                        onClick={handleAddDocument}
                                                    >
                                                        <AddwithWhiteCircle /> Add
                                                    </button>
                                                </div>

                                                {formData.email_documents.map((doc, index) => (
                                                    <div key={index} className="flex gap-2">
                                                        <div className="flex-column">
                                                            <label className="form-labels announce-date">
                                                                Document Name<span className="required">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="emp-letter-form-input emp_email_input emp-letter-small-input"
                                                                placeholder="Document Name"
                                                                value={doc.doc_name || ""}
                                                                onChange={(e) => handleChange(e, index)}
                                                                name="doc_name"
                                                            />
                                                            {errors[`email_documents[${index}].doc_name`] && (
                                                                <span className="error-message font-size-text">
                                                                    {errors[`email_documents[${index}].doc_name`]}
                                                                </span>
                                                            )}
                                                        </div>

                                                        <div className="flex-column">
                                                            <label className="form-labels announce-date">
                                                                Document Attachment
                                                                <span className="required">*</span>
                                                            </label>
                                                            <div
                                                                className="file-upload-container flex-row justify-between file-in-upload"
                                                                style={{ padding: "0 3px" }}
                                                            >
                                                                <label
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        width: "29vw",
                                                                        padding: "0px 10px",
                                                                    }}
                                                                    htmlFor={`doc_file_${index}`}
                                                                >
                                                                    <CloudUpload />
                                                                    <span
                                                                        className="truncate-url"
                                                                        style={{ marginLeft: "20px" }}
                                                                    >
                                                                        {doc.doc_file
                                                                            ? doc.doc_file.name
                                                                            : "No files selected"}
                                                                    </span>
                                                                </label>
                                                                <input
                                                                    type="file"
                                                                    id={`doc_file_${index}`}
                                                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpeg,.jpg"
                                                                    onChange={(e) => handleFileChange(e, index)}
                                                                    style={{ display: "none" }}
                                                                />
                                                                {doc.doc_file && (
                                                                    <span
                                                                        className="file-clear"
                                                                        onClick={() => handleFileClear(index)}
                                                                    >
                                                                        Clear
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {errors[
                                                                `email_documents[${index}].doc_file`
                                                            ] && (
                                                                    <span className="error-message font-size-text">
                                                                        {errors[`email_documents[${index}].doc_file`]}
                                                                    </span>
                                                                )}
                                                        </div>

                                                        <button
                                                            className="remove-btn"
                                                            style={{ marginTop: "32px" }}
                                                            type="button"
                                                            onClick={() => handleRemoveDocument(index)}
                                                        >
                                                            <CrosswithGreyCircle />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* ── Action buttons ── */}
                                    <div className="button-models">
                                        <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}
                                        >
                                            Cancel
                                        </button>
                                        {/* 
                    <ViewLetterBuilder
                      templateID={formData.letter_template}
                      formatID={formData.letter_content}
                      empLetterData={formData}
                    /> */}

                                        <button
                                            type="submit"
                                            className="model-button model-button-leave font-weight500 font-size-heading"
                                            disabled={loading}
                                            onClick={handleSubmit}
                                        >
                                            {loading
                                                ? "Creating..."
                                                : `Create Letter${formData.emp_code.length > 1
                                                    ? ` (${formData.emp_code.length})`
                                                    : ""
                                                }`}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        {/* ── Global error summary ── */}
                        {isSubmitted && Object.keys(errors).length > 0 && (
                            <p className="error-message font-size-text">
                                {Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">
                                        Please fill all mandatory fields!
                                    </h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((f) =>
                                                f
                                                    .replace(/_/g, " ")
                                                    .replace(/\b\w/g, (c) => c.toUpperCase())
                                            )
                                            .join(", ") + " are required!"}
                                    </h6>
                                )}
                            </p>
                        )}
                    </div>
                </Modal.Body>

                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Modal>
        </>
    );
};


const EmpLetterDelete = ({ i, getEmployeeLettersData }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/letter-builder-employeeletterwithvariables-update-delete/${i.id}/`
            );
            if (res.status === 200) {
                await getEmployeeLettersData();
                setShow(false);
                toast.success(i?.id && "Employee Letter Deleted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Employee Letter </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to Delete Employee Letter
                        {/* <b>{i?.emp_code}</b> */}
                        <div className="button-models">
                            <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};


const ViewEmpMailFormat = ({ letterFormat }) => {
    const [showPreview, setShowPreview] = useState(false);

    const handleShow = () => setShowPreview(true);
    const handleClose = () => setShowPreview(false);

    return (
        <>
            <button
                title="View"
                style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
                onClick={handleShow}
            >   <Eye />
                View Mail
            </button>

            <Modal
                show={showPreview}
                onHide={handleClose}
                centered
                dialogClassName="modal-dialog custom-mail-modal"
            >
                <Modal.Header closeButton className="mail-modal-header">
                    <Modal.Title className="mail-modal-title">
                        Employee Mail Preview
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="mail-modal-body">

                    {/* Subject Section */}
                    <div className="mail-section">
                        <div className="mail-label">
                            Subject
                        </div>

                        <div className="mail-content-box subject-box">
                            {letterFormat?.email_subject || "-"}
                        </div>
                    </div>

                    {/* Body Section */}
                    <div className="mail-section">
                        <div className="mail-label">
                            Email Body
                        </div>

                        <div className="mail-content-box body-box">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: letterFormat?.email_body || "-"
                                }}
                            />
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};

export {
    AddLetterTemplate,
    AddLetterFormat,
    AddEmployeeLetter,
    LetterUpdate,
    LetterDelete,
    ViewLetterBuilder,
    LetterFormatUpdate,
    LetterFormatDelete,
    // EmpLetterUpdate,
    EmpLetterDelete,
    ViewEmpMailFormat,
};


